/* global gdAlertify */
import React from 'react';
import { useState, useEffect, useMemo } from "react";
import BuscarPaciente from "./components/BuscarPaciente";
import { formatDate, formatMoney } from "../utils/utils";
import axiosInstance from "../config/axiosConfig";
import GdTable from "./components/GdTable";  // Importar GdTable
import BuscarAuxiliar from "./components/BuscarAuxiliar";
import Select from "react-select";
import ModalRecordatoriosPaciente from "./components/ModalRecordatoriosPaciente"; // Importar modal recordatorios
import VacacionesModal from "./components/VacacionesModal";
import NoEnviarPacienteAuxiliarModal from "./components/NoEnviarPacienteAuxiliarModal";
import {
    getNoEnviarPacienteStatus,
    formatAuxiliarSearchLabel,
} from "../utils/noEnviarPaciente";

/* global gdAlertify */


const InfoHeader = ({ row }) => {
    if (!row) return null;

    var { pacienteNombre, pacienteRut, auxiliarNombre, fecha, turno } = row;
    const labelTurno = turno === "1" ? "Día" : "Noche";

    if (row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0) {
        auxiliarNombre = row.reemplazoNombre;
    }

    return (
        <div className="info-header px-3 py-2 border-bottom bg-light">
            <small>
                <strong>Paciente:</strong> {pacienteNombre} ({pacienteRut})
                &nbsp;|&nbsp;
                <strong>Auxiliar:</strong> {auxiliarNombre || '-'}
                &nbsp;|&nbsp;
                <strong>Fecha:</strong> {formatDate(fecha)}
                &nbsp;|&nbsp;
                <strong>Turno:</strong> {labelTurno}
            </small>
        </div>
    );
};

const getTurnoAuxiliarActualInfo = (row) => {
    if (!row) {
        return {
            id: null,
            nombre: "",
            rut: "",
        };
    }

    if (row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0) {
        return {
            id: row.reemplazoID || row.auxiliarID || null,
            nombre: row.reemplazoNombre || "",
            rut: row.reemplazoRut || "",
        };
    }

    return {
        id: row.auxiliarID || null,
        nombre: row.auxiliarNombre || "",
        rut: row.auxiliarRut || "",
    };
};

const NotaModal = ({ isOpen, onClose, onConfirm, row, periodo }) => {
    const [tipoNota, setTipoNota] = useState("individual");
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");
    const [observation, setObservation] = useState("");
    const [notasInternas, setNotasInternas] = useState(""); // Notas internas
    const [marca, setMarca] = useState(row.marca); // NUEVO
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Inicializa cuando abre modal
    useEffect(() => {
        if (isOpen && row) {
            setObservation(row.notes || "");
            setNotasInternas(row.notas_internas || ""); // Cargar notas internas
            setTipoNota("individual");
            setFechaInicio(row.fecha || "");
            setFechaFin("");

            // Cargar estado actual del día marcado
            setMarca(row.marca ? 1 : 0);
        }
    }, [isOpen, row]);

    // Calcula fechas válidas del periodo
    useEffect(() => {
        if (!periodo) return;
        const [anioStr, mesStr] = periodo.split("-");
        const anio = parseInt(anioStr, 10);
        const mes = parseInt(mesStr, 10);
        const desde = new Date(anio, mes - 1, 26);
        const hasta = new Date(anio, mes, 25);
        setPeriodoDesde(desde.toISOString().split("T")[0]);
        setPeriodoHasta(hasta.toISOString().split("T")[0]);
    }, [periodo]);

    if (!isOpen || !row) return null;

    const handleSubmit = (e) => {
        e.preventDefault();

        if (tipoNota === "rango") {
            if (!fechaInicio || !fechaFin) {
                gdAlertify.notiError("Debe ingresar fechas inicio y fin");
                return;
            }
            if (fechaInicio > fechaFin) {
                gdAlertify.notiError("Fecha inicio no puede ser mayor que la de fin");
                return;
            }
            /* 
            if (fechaInicio < periodoDesde) {
                gdAlertify.notiError(`Las fechas deben ser mayores a ${periodoDesde}`);
                return;
            } */

            gdAlertify.confirm({
                title: "Confirmar Nota por Rango",
                message: `⚠️ Esta acción reemplazará todas las notas entre ${fechaInicio} y ${fechaFin}. ¿Desea continuar?`,
                onConfirm: () => handleConfirmGuardar(true),
                onCancel: () => gdAlertify.notify("Cancelado", "error"),
            });
        } else {
            handleConfirmGuardar(false);
        }
    };

    const handleConfirmGuardar = async (esRango) => {
        gdAlertify.confirm({
            title: "Confirmar Nota",
            message: esRango
                ? "¿Está seguro de guardar la nota para el rango seleccionado?"
                : "¿Está seguro de guardar la nota?",
            onConfirm: async () => {
                setIsSubmitting(true);
                gdAlertify.showLoader();
                try {
                    const payload = {
                        data: row,
                        nota: observation,
                        notas_internas: notasInternas, // Enviar notas internas
                        tipoNota,
                        fechaInicio: esRango ? fechaInicio : row.fecha,
                        fechaFin: esRango ? fechaFin : row.fecha,
                        marca: marca, // NUEVO: enviar marca
                    };

                    const resp = await axiosInstance.post("/turnos/nota", payload);

                    if (!resp.data.error) {
                        gdAlertify.notiSuccess(resp.data.message || "Nota guardada correctamente");
                        onConfirm();
                        onClose();
                    } else {
                        gdAlertify.notiError(resp.data.message || "Error al guardar la nota");
                    }
                } catch (err) {
                    gdAlertify.notiError("Error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                    setIsSubmitting(false);
                }
            },
            onCancel: () => gdAlertify.notify("Cancelado", "error"),
        });
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Agregar Nota</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="modal-body">
                                <InfoHeader row={row} />

                                {/* Tipo de nota */}
                                <div className="mb-3">
                                    <label className="form-label">Tipo de nota:</label>
                                    <select
                                        className="form-select"
                                        value={tipoNota}
                                        onChange={(e) => setTipoNota(e.target.value)}
                                        disabled={isSubmitting}
                                    >
                                        <option value="individual">
                                            Fecha seleccionada ({row.fecha})
                                        </option>
                                        <option value="rango">Rango de fechas</option>
                                    </select>
                                </div>

                                {/* Si es rango, muestra el formulario */}
                                {tipoNota === "rango" && (
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Inicio:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaInicio}
                                                onChange={(e) => setFechaInicio(e.target.value)}
                                                min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Fin:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaFin}
                                                onChange={(e) => setFechaFin(e.target.value)}
                                                min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* Campo nota */}
                                <div className="mb-3">
                                    <label className="form-label">Nota:</label>
                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        value={observation}
                                        onChange={(e) => setObservation(e.target.value)}
                                        disabled={isSubmitting}
                                    />
                                </div>

                                {/* Campo notas internas */}
                                <div className="mb-3">
                                    <label className="form-label">Notas Internas:</label>
                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        value={notasInternas}
                                        onChange={(e) => setNotasInternas(e.target.value)}
                                        disabled={isSubmitting}
                                        placeholder="Notas internas (no visibles para el cliente)"
                                    />
                                </div>

                                {/* NUEVO: checkbox marcar amarillo */}
                                <div className="form-check mb-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="marcaDia"
                                        checked={marca === 1}
                                        onChange={(e) => setMarca(e.target.checked ? 1 : 0)}
                                        disabled={isSubmitting}
                                    />
                                    <label className="form-check-label" htmlFor="marcaDia">
                                        Marcar día en amarillo
                                    </label>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Guardando..." : "Guardar Nota"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};


const ColorTurnoModal = ({ isOpen, onClose, onConfirm, row, periodo }) => {
    const [color, setColor] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Nuevos estados solicitados
    const [tipoTurno, setTipoTurno] = useState("1"); // 1=Día, 2=Noche, 3=Día y Noche
    const [tipoFecha, setTipoFecha] = useState("individual"); // individual | rango
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [aplicaAuxiliar, setAplicaAuxiliar] = useState("actual"); // actual | todos

    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");

    useEffect(() => {
        if (isOpen && row) {
            setColor(row.color || 0);
            setTipoTurno(row.turno === "1" ? "1" : "2");
            setTipoFecha("individual");
            setFechaInicio(row.fecha || "");
            setFechaFin("");
            setAplicaAuxiliar("actual");
        }
    }, [isOpen, row]);

    // Calcular fechas válidas del periodo (similar a NotaModal)
    useEffect(() => {
        if (!periodo) return;
        const [anioStr, mesStr] = periodo.split("-");
        const anio = parseInt(anioStr, 10);
        const mes = parseInt(mesStr, 10);
        const desde = new Date(anio, mes - 1, 26);
        const hasta = new Date(anio, mes, 25);
        setPeriodoDesde(desde.toISOString().split("T")[0]);
        setPeriodoHasta(hasta.toISOString().split("T")[0]);
    }, [periodo]);

    if (!isOpen || !row) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validaciones de rango
        if (tipoFecha === "rango") {
            if (!fechaInicio || !fechaFin) {
                gdAlertify.notiError("Debe ingresar fechas inicio y fin");
                return;
            }
            if (fechaInicio > fechaFin) {
                gdAlertify.notiError("Fecha inicio no puede ser mayor que la de fin");
                return;
            }
        }

        setIsSubmitting(true);
        gdAlertify.showLoader();
        try {
            const payload = {
                data: row,
                nota: row.notes,
                notas_internas: row.notas_internas,
                tipoNota: tipoFecha, // Usamos tipoFecha como tipoNota para el backend
                fechaInicio: tipoFecha === "rango" ? fechaInicio : row.fecha,
                fechaFin: tipoFecha === "rango" ? fechaFin : row.fecha,
                marca: row.marca,
                color: color,
                tipoTurno: tipoTurno,
                auxiliarID: aplicaAuxiliar === "actual" ? row.auxiliarID : 0,
            };

            const resp = await axiosInstance.post("/turnos/nota", payload);

            if (!resp.data.error) {
                gdAlertify.notiSuccess("Color actualizado correctamente");
                onConfirm();
                onClose();
            } else {
                gdAlertify.notiError(resp.data.message || "Error al actualizar color");
            }
        } catch (err) {
            gdAlertify.notiError("Error al conectar con el servidor.");
        } finally {
            gdAlertify.hideLoader();
            setIsSubmitting(false);
        }
    };

    const colorOptions = [
        { value: 0, label: "Automático (Reglas del sistema)", hex: "#e9ecef", border: "#6c757d" },
        { value: 1, label: "Ninguno (Forzar blanco)", hex: "#ffffff", border: "#adb5bd" },
        { value: 2, label: "Azul (Manual)", hex: "#b1c1f2", border: "#0d6efd" },
        { value: 3, label: "Amarillo (Manual)", hex: "#fdfd96", border: "#ffc107" },
    ];

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Cambiar Color del Turno</h5>
                                <button type="button" className="btn-close" onClick={onClose} disabled={isSubmitting} />
                            </div>
                            <div className="modal-body">
                                <InfoHeader row={row} />
                                <div className="mb-3 mt-3">
                                    <label className="form-label">Seleccione un color:</label>
                                    <div className="list-group">
                                        {colorOptions.map((opt) => (
                                            <button
                                                key={opt.value}
                                                type="button"
                                                className={`list-group-item list-group-item-action d-flex align-items-center ${color === opt.value ? 'active' : ''}`}
                                                onClick={() => setColor(opt.value)}
                                                disabled={isSubmitting}
                                            >
                                                <span 
                                                    style={{ 
                                                        width: '15px', 
                                                        height: '15px', 
                                                        backgroundColor: opt.hex, 
                                                        border: `1px solid ${opt.border}`, 
                                                        display: 'inline-block',
                                                        marginRight: '12px',
                                                        borderRadius: '2px'
                                                    }}
                                                ></span>
                                                {opt.label}
                                            </button>
                                        ))}
                                    </div>

                                    {/* 1. Selección de Turno */}
                                    <div className="mt-3">
                                        <label className="form-label">Aplicar a turno:</label>
                                        <select 
                                            className="form-select" 
                                            value={tipoTurno} 
                                            onChange={(e) => setTipoTurno(e.target.value)}
                                            disabled={isSubmitting}
                                        >
                                            <option value={row.turno === "1" ? "1" : "2"}>Solo turno actual ({row.turno === "1" ? "Día" : "Noche"})</option>
                                            <option value="3">Día y Noche</option>
                                        </select>
                                    </div>

                                    {/* 2. Selección de Fecha */}
                                    <div className="mt-3">
                                        <label className="form-label">Aplicar en fechas:</label>
                                        <select 
                                            className="form-select" 
                                            value={tipoFecha} 
                                            onChange={(e) => setTipoFecha(e.target.value)}
                                            disabled={isSubmitting}
                                        >
                                            <option value="individual">Fecha seleccionada ({row.fecha})</option>
                                            <option value="rango">Rango de fechas</option>
                                        </select>
                                    </div>

                                    {tipoFecha === "rango" && (
                                        <div className="row mt-2 g-2">
                                            <div className="col-6">
                                                <label className="form-label small">Inicio:</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control form-control-sm" 
                                                    value={fechaInicio} 
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                    disabled={isSubmitting}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="form-label small">Fin:</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control form-control-sm" 
                                                    value={fechaFin} 
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                    disabled={isSubmitting}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* 3. Selección de Auxiliar */}
                                    <div className="mt-3">
                                        <label className="form-label">Aplicar para:</label>
                                        <select 
                                            className="form-select" 
                                            value={aplicaAuxiliar} 
                                            onChange={(e) => setAplicaAuxiliar(e.target.value)}
                                            disabled={isSubmitting}
                                        >
                                            <option value="actual">Solo auxiliar actual ({row.auxiliarNombre || 'Sin asignar'})</option>
                                            <option value="todos">Todos los auxiliares</option>
                                        </select>
                                    </div>

                                    <p className="text-muted small mt-3">
                                        <i className="bi bi-info-circle me-1"></i>
                                        El color seleccionado tendrá prioridad sobre el color automático del calendario.
                                    </p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isSubmitting}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? "Guardando..." : "Guardar Color"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};


const ReemplazarAuxiliar = ({ isOpen, onClose, onConfirm, paciente, row, periodo }) => {
    const esApoyo = row?.es_apoyo === 1;
    const [auxiliarAntiguo, setAuxiliarAntiguo] = useState(
        row?.auxiliarID !== undefined ? row.auxiliarID : ""
    );
    const [observacion, setObservacion] = useState("");
    const [valorTurno, setValorTurno] = useState(0);
    const [valorTurnoBaseCalculo, setValorTurnoBaseCalculo] = useState(0);
    const [valorTurnoEditado, setValorTurnoEditado] = useState(false);
    const [valorColacion, setValorColacion] = useState(0);
    const [valorLocomocion, setValorLocomocion] = useState(0);
    const [valorOtro, setValorOtro] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [auxiliarInfo, setAuxiliarInfo] = useState(null);

    const [tipoReemplazo, setTipoReemplazo] = useState("individual");
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [enviarWsp, setEnviarWsp] = useState(false); // Nuevo: switch WSP (por defecto desactivado)

    // Nuevo estado para tipo de turno: "1"=Solo día, "2"=Solo noche, "3"=Día y noche
    const [tipoTurno, setTipoTurno] = useState("1");

    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");

    // Calcular fechas límites a partir de "periodo" (formato "YYYY-MM")
    useEffect(() => {
        if (!periodo) return;

        const [anioStr, mesStr] = periodo.split("-");
        const mes = parseInt(mesStr, 10) - 1; // 0-based
        const anio = parseInt(anioStr, 10);

        // Desde: día 26 del mes anterior
        const desde = new Date(anio, mes - 1, 26);
        // Hasta: día 25 del mes actual
        const hasta = new Date(anio, mes, 25);

        setPeriodoDesde(desde.toISOString().split("T")[0]);
        setPeriodoHasta(hasta.toISOString().split("T")[0]);
    }, [periodo]);

    // Cada vez que se abre el modal, re-inicializar valores
    useEffect(() => {
        if (isOpen) {
            setTipoReemplazo("individual");
            setFechaInicio(row?.fecha || "");
            setFechaFin("");
            setAuxiliarInfo(null);
            setObservacion("");
            setValorColacion(row.valorColacionRt ? String(row.valorColacionRt) : String(row.valorColacion));
            setValorLocomocion(row.valorLocomocionRt ? String(row.valorLocomocionRt) : String(row.valorMovilizacion));
            setValorOtro(row.valorOtroRt ? String(row.valorOtroRt) : String(row.valorOtro));

            setAuxiliarAntiguo(row?.auxiliarID ?? "");

            let valorTurno = row.valorTurnoRt ? String(row.valorTurnoRt) : String(row.valorTurno)

            if (parseFloat(row.extra) > 0 && !auxiliarAntiguo) {
                // 1. Tomamos el valor base del turno (del acuerdo)
                const valorBase = parseFloat(row.valorTurnoBase || 0);
                // 2. Obtenemos el porcentaje extra (ej. 50 para 50%)
                const extraPorcentaje = parseFloat(row.extra);
                // 3. Calculamos el monto del aumento
                const aumento = Math.round(valorBase * (extraPorcentaje / 100));
                // 4. Sumamos al base para obtener el total
                valorTurno = valorBase + aumento;

            }

            setValorTurnoBaseCalculo(Number(valorTurno) || 0);
            setValorTurno(0);
            setValorTurnoEditado(false);

            // Mapear row.tipoTurno ("day"|"night"|"1"|"2"|"3") a nuestro estado
            let initialTipo = "1"; // por defecto
            if (row?.tipo === "day") {
                initialTipo = "1";
            } else if (row?.tipo === "night") {
                initialTipo = "2";
            } else if (row?.tipo === "daynight") {
                initialTipo = "3";
            } else if (["1", "2", "3"].includes(String(row?.tipoTurno))) {
                initialTipo = String(row.tipoTurno);
            }
            setTipoTurno(initialTipo);
        }
    }, [isOpen, row]);

    if (!isOpen) return null;

    const noEnviarStatus = getNoEnviarPacienteStatus(auxiliarInfo);
    const valorTurnoEfectivo = valorTurnoEditado ? Number(valorTurno || 0) : Number(valorTurnoBaseCalculo || 0);

    const handleNumChange = (setter) => (e) => {
        const v = e.target.value;
        if (v === "") setter("");      // usuario borró el campo
        else setter(v);                // guardamos el string del número
    };

    const handleValorTurnoChange = (e) => {
        const v = e.target.value;
        setValorTurnoEditado(true);
        if (v === "") {
            setValorTurno("");
            return;
        }
        setValorTurno(v);
    };

    const handleSeleccionAuxiliar = (auxiliar) => {
        setAuxiliarInfo(auxiliar);
    };

    const crearMensajeWhatsapp = () => {
        const nombreAux = auxiliarInfo?.nombre || "Auxiliar";

        let periodoLabel = "";
        if (String(tipoTurno) === "1") periodoLabel = "Día";
        else if (String(tipoTurno) === "2") periodoLabel = "Noche";
        else if (String(tipoTurno) === "3") periodoLabel = "Día y Noche";

        let fechaTexto = "";
        if (tipoReemplazo === "individual") {
            fechaTexto = `📅 *Fecha:* ${formatDate(row.fecha)}`;
        } else {
            fechaTexto = `📅 *Periodo:* ${formatDate(fechaInicio)} al ${formatDate(fechaFin)}`;
        }

        const comoLlegarTexto = row.paciente_comoLlegar ? `\n🗺️ *Cómo llegar:* ${row.paciente_comoLlegar}` : '';

        return `Hola ${nombreAux}, te contacto para confirmar asignación:
        
🏥 *Paciente:* ${row.pacienteNombre}
📍 *Dirección:* ${row.paciente_direccion || 'No especificada'}
🩺 *Patología:* ${row.paciente_diagnostico || 'No especificada'}${comoLlegarTexto}
${fechaTexto}
🕐 *Turno:* ${periodoLabel}
⏰ *Horario:* ${row.horaInicio || '?'} a ${row.horaFin || '?'}

💰 *Valor del turno:* $${formatMoney(valorTurnoEfectivo)}
🍽️ *Colación:* $${formatMoney(valorColacion)}
🚗 *Movilización:* $${formatMoney(valorLocomocion)}

Por favor confirma tu asistencia. 🙌`;
    };

    const handleSubmit = async () => {
        if (!auxiliarInfo) {
            gdAlertify.notiError("Debe seleccionar un auxiliar");
            return;
        }

        // Validar al menos un monto > 0
        const total = valorTurnoEfectivo + Number(valorColacion || 0) + Number(valorLocomocion || 0) + Number(valorOtro || 0);
        if (total <= 0) {
            gdAlertify.notiError("Valor debe ser mayor a 0");
            return;
        }

        // Si es rango, validar fechas
        if (tipoReemplazo === "rango") {
            if (!fechaInicio || !fechaFin) {
                gdAlertify.notiError("Debe ingresar ambas fechas");
                return;
            }
            if (fechaInicio > fechaFin) {
                gdAlertify.notiError("Fecha de inicio no puede ser mayor que la de fin");
                return;
            }
            /* 
            if (fechaInicio < periodoDesde) {
                gdAlertify.notiError(
                    `Fechas deben ser mayor a ${formatDate(periodoDesde)}`
                );
                return;
            } */
        }

        setIsSubmitting(true);
        gdAlertify.showLoader();

        try {
            const data = {
                pacienteId: row.pacienteID,
                auxiliar: auxiliarInfo,
                auxiliarAntiguo: auxiliarAntiguo,
                data: row,
                valorTurno: valorTurnoEfectivo,
                valorColacion,
                valorLocomocion,
                valorOtro,
                nota: observacion,
                tipoReemplazo,          // "individual" o "rango"
                fechaInicio: tipoReemplazo === "rango" ? fechaInicio : null,
                fechaFin: tipoReemplazo === "rango" ? fechaFin : null,
                tipoTurno,              // "1", "2" o "3"
                es_apoyo: row.es_apoyo,
            };

            let response = await axiosInstance.post("/turnos/asignar", data);
            if (!response.data.error) {
                gdAlertify.notiSuccess(response.data.message || "Asignación exitosa");
                onConfirm(); // Recarga la tabla de inmediato

                if (enviarWsp && auxiliarInfo?.celular) {
                    gdAlertify.confirm({
                        title: "Proceder",
                        message: "¿Deseas enviar el resumen por WhatsApp al auxiliar?",
                        onConfirm: () => {
                            const mensaje = crearMensajeWhatsapp();
                            const phoneNumber = "56" + auxiliarInfo.celular.replace(/\D/g, '');
                            const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(mensaje)}`;
                            window.open(whatsappUrl, '_blank');
                            onClose();
                        },
                        onCancel: () => {
                            onClose();
                        }
                    });
                } else {
                    onClose();
                }
            } else {
                gdAlertify.notiError(response.data.message);
                onConfirm();
                onClose();
            }

            // Resetear estados
            setObservacion("");
            setValorTurno(0);
            setValorTurnoBaseCalculo(0);
            setValorTurnoEditado(false);
            setValorColacion("");
            setValorLocomocion("");
            setValorOtro("");
            setFechaInicio("");
            setFechaFin("");
            setTipoReemplazo("individual");
            setTipoTurno("1");
        } catch (error) {
            console.error("Error al asignar auxiliar:", error);
            alert("Ocurrió un error al asignar al paciente");
        } finally {
            gdAlertify.hideLoader();
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Cambiar Auxiliar</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                disabled={isSubmitting}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <InfoHeader row={row} />
                            <p>¿Estás seguro de que deseas reemplazar al auxiliar?</p>

                            <div className="mb-3">
                                <BuscarAuxiliar
                                    onSelect={handleSeleccionAuxiliar}
                                    pacienteId={row?.pacienteID}
                                    pacienteNombre={row?.pacienteNombre}
                                    warnOnNoEnviar={true}
                                />
                            </div>

                            {auxiliarInfo && (
                                <div className={`alert ${noEnviarStatus.active ? "alert-warning" : "alert-light border"} py-2`}>
                                    <div className="fw-bold">
                                        Auxiliar seleccionado:{" "}
                                        {formatAuxiliarSearchLabel(auxiliarInfo, {
                                            includeRut: false,
                                            includeNoEnviarSuffix: false,
                                        })}
                                    </div>
                                    {noEnviarStatus.active && (
                                        <div className="small mt-1">
                                            <i className="bi bi-exclamation-triangle me-1"></i>
                                            Marcado como NO ENVIAR A ESTE DOMICILIO para este paciente.
                                            {noEnviarStatus.observation ? ` Obs: ${noEnviarStatus.observation}` : ""}
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="mb-3">
                                <label className="form-label">Tipo de reemplazo:</label>
                                <select
                                    className="form-select"
                                    value={tipoReemplazo}
                                    onChange={(e) => setTipoReemplazo(e.target.value)}
                                    disabled={isSubmitting}
                                >
                                    <option value="individual">
                                        Fecha Seleccionada ({row.fecha.split('-').reverse().join('-')} - {row.tipo == 'day' ? 'Día' : 'Noche'})
                                    </option>
                                    {!esApoyo && <option value="rango">Rango de fechas</option>}
                                </select>
                            </div>

                            {tipoReemplazo === "rango" && (
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Fecha Inicio:</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fechaInicio}
                                            onChange={(e) => setFechaInicio(e.target.value)}
                                            min={periodoDesde}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Fecha Fin:</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fechaFin}
                                            onChange={(e) => setFechaFin(e.target.value)}
                                            min={periodoDesde}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                    <p className="text-muted mt-2">
                                        Periodo válido: {formatDate(periodoDesde)} al {formatDate(periodoHasta)}
                                    </p>
                                </div>
                            )}

                            {/* Selector para “Tipo Turno” sin prefijo numérico en el label */}
                            <div className="mb-3">
                                <label className="form-label">Tipo Turno:</label>
                                <select
                                    className="form-select"
                                    value={tipoTurno}
                                    onChange={(e) => setTipoTurno(e.target.value)}
                                    disabled={isSubmitting}
                                >
                                    <option value={row.tipo == 'day' ? 1 : 2}>Actual - {row.tipo == 'day' ? 'Día' : 'Noche'}</option>
                                    {!esApoyo && (<option value="3">Día y noche</option>)}
                                </select>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-3 text-center"><b>Se actualiza el valor para todos los turnos entre la fecha seleccionada</b></div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Valor Turno:</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={valorTurno}
                                        onChange={handleValorTurnoChange}
                                        disabled={isSubmitting}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Valor Colación:</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={valorColacion}
                                        onChange={(e) => setValorColacion(e.target.value)}
                                        disabled={isSubmitting}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Valor Locomoción:</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={valorLocomocion}
                                        onChange={(e) => setValorLocomocion(e.target.value)}
                                        disabled={isSubmitting}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Valor Otro:</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={valorOtro}
                                        onChange={(e) => setValorOtro(e.target.value)}
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Observación (opcional):</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={observacion}
                                    onChange={(e) => setObservacion(e.target.value)}
                                    disabled={isSubmitting}
                                ></textarea>
                            </div>

                            <div className="form-check form-switch mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="enviarWsp"
                                    checked={enviarWsp}
                                    onChange={(e) => setEnviarWsp(e.target.checked)}
                                    disabled={isSubmitting}
                                />
                                <label className="form-check-label" htmlFor="enviarWsp">
                                    Enviar resumen por WhatsApp al finalizar
                                </label>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                                disabled={isSubmitting}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleSubmit}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Enviando..." : "Confirmar"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const IngresoAdicional = ({ isOpen, onClose, onConfirm, row }) => {
    const esApoyo = row?.es_apoyo === 1;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fueraStgo, setFueraStgo] = useState(false);

    const [tipoReemplazo, setTipoReemplazo] = useState("individual");
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");

    const [selectedCobro, setSelectedCobro] = useState(null);
    const [tipoTurno, setTipoTurno] = useState("1");

    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");

    const [auxiliarTercero, setAuxiliarTercero] = useState(null); // 👈 nuevo auxiliar opcional

    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    const [datosAdicional, setDatosAdicional] = useState({
        pacienteID: 0,
        auxiliarID: 0,
        auxiliarRemplazoID: 0,
        horasExtras: '',
        valorTurno: '',
        valorColacion: '',
        valorMovilizacion: '',
        valorOtro: '',
        motivoAdicional: "",
        fechaAdicional: formattedDate,
        fueraStgo: false,
        tipoTurno: 1
    });

    const [auxiliares] = useState([
        { value: 1, label: "Paga SK" },
        { value: 2, label: "Cobrar al paciente" },
    ]);

    useEffect(() => {
        if (!isOpen || !row) return;

        let auxiliarID = row.auxiliarID;
        if (row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0) {
            auxiliarID = row.reemplazoID;
        }

        // Si viene idAdicional, es EDICIÓN
        const isEdit = !!row.idAdicional;

        setFueraStgo(row.fueraStgo === 1); // Si viene de edición, respetar flag
        
        // Si es edición y el ID del auxiliar es distinto al del turno original,
        // seteamos auxiliarTercero para que se vea en el bloque azul.
        if (isEdit && row.auxiliarID && row.auxiliarTurnoID && row.auxiliarID !== row.auxiliarTurnoID) {
             setAuxiliarTercero({
                 id: row.auxiliarID,
                 nombre: row.auxiliarNombre || "Auxiliar",
                 apellidoPaterno: "", // No siempre disponible en 'item'
                 apellidoMaterno: ""
             });
        } else {
             setAuxiliarTercero(null);
        }

        // Manejo del cobro (Paga SK / Cobrar Paciente) para edición
        if (isEdit && row.auxiliarRemplazoID) {
            const opt = auxiliares.find(a => a.value === row.auxiliarRemplazoID);
            setSelectedCobro(opt || null);
        } else {
            setSelectedCobro(null);
        }

        setDatosAdicional({
            idAdicional: row.idAdicional || null, // ID para el backend
            pacienteID: row.pacienteID,
            auxiliarID: isEdit ? (row.auxiliarID || auxiliarID) : auxiliarID,
            auxiliarRemplazoID: row.auxiliarRemplazoID || 0,
            
            horasExtras: row.horasExtras || '',
            valorTurno: (isEdit ? '' : 0),
            valorColacion: isEdit ? (row.valorColacion || '') : 0,
            valorMovilizacion: isEdit ? (row.valorMovilizacion || (row.valorLocomocion || '')) : 0,
            valorOtro: isEdit ? (row.valorOtro || '') : 0,
            
            motivoAdicional: row.motivoAdicional || "",
            fechaAdicional: row.fechaAdicional || row.fecha, // En edición suele venir fechaAdicional
            
            fueraStgo: row.fueraStgo === 1,
            tipoTurno: row.tipo == 'day' ? 1 : 2, // Por defecto
        });

        // Ajustar tipoTurno si viene específico en la edición
        let initialTipo = "1";
        // Prioridad: el que viene en el item editado (row.tipo_turno o similar si existiera)
        // Como 'row' es un mix, validamos:
        if (row?.tipo === "day") {
            initialTipo = "1";
        } else if (row?.tipo === "night") {
            initialTipo = "2";
        } else if (row?.tipo === "daynight") {
            initialTipo = "3";
        } else if (["1", "2", "3"].includes(String(row?.tipoTurno))) {
            initialTipo = String(row.tipoTurno);
        }
        
        // En edición, si el item tenía un tipo específico, intentamos respetarlo
        // (Nota: el item mapeado en onEditar no siempre trae 'tipoTurno' explícito 
        //  salvo que venga en 'row.adicionales'). 
        //  Si hiciera falta, asegurarse de mapear 'tipo_fecha' -> 'tipoTurno' en onEditar.
        if (isEdit && row.tipo_fecha) { 
             // 1=Dia, 2=Noche (según tabla mostrada)
             initialTipo = String(row.tipo_fecha);
        }

        setTipoTurno(initialTipo);
   
        // Si es edición y tiene fechas de inicio/fin (rango), setearlas
        if (isEdit && (row.fechaInicio || row.fechaFin)) {
             setTipoReemplazo("rango");
             setFechaInicio(row.fechaInicio || "");
             setFechaFin(row.fechaFin || "");
        } else {
             setTipoReemplazo("individual");
             setFechaInicio("");
             setFechaFin("");
        }

    }, [isOpen, row, auxiliares]);

    const handleAuxiliar = (opt) => {
        setSelectedCobro(opt);
        if (!opt) {
            setDatosAdicional((d) => ({ ...d, auxiliarRemplazoID: 0 }));
            return;
        }
        let valor = opt.value;
        if (valor === 3) {
            valor = row.auxiliarID;
        }
        setDatosAdicional((d) => ({
            ...d,
            auxiliarRemplazoID: valor,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const num = value || '';

        if (name === "horasExtras") {
            const horas = parseFloat(num) || 0;
            const baseTurno = row.valorTurnoBase || 0;
            let baseHora = baseTurno / 12;

            // Si está fuera de Santiago, las horas extras también llevan el recargo del 35%
            if (fueraStgo) {
                baseHora = baseHora * 1.35;
            }

            const valorHorasExtras = baseHora * horas;

            if (fueraStgo) {
                // Si está fuera de Santiago, incluimos automáticamente el recargo del 35% del turno base
                const recargo = baseTurno * 0.35;
                const valorTotal = valorHorasExtras + recargo;

                return setDatosAdicional((d) => ({
                    ...d,
                    horasExtras: horas,
                    valorTurno: parseFloat(valorTotal.toFixed(2)),
                }));
            } else {
                // Cálculo normal sin recargo
                return setDatosAdicional((d) => ({
                    ...d,
                    horasExtras: horas,
                    valorTurno: parseFloat(valorHorasExtras.toFixed(2)),
                }));
            }
        }

        setDatosAdicional((d) => ({
            ...d,
            [name]: name.startsWith("valor") ? num : value,
        }));
    };

    const toggleFueraStgo = () => {
        setFueraStgo((prev) => {
            const nuevoEstado = !prev;

            if (nuevoEstado) {
                // Activando "Fuera de Santiago"
                
                const recargo = 1.35;
                const baseTurno = row.valorTurnoBase || 0;
                const turnoRecargado = parseFloat((baseTurno * recargo).toFixed(2));
                
                // Calcular horas extras si existen (con recargo del 35%)
                const horasExtras = parseFloat(datosAdicional.horasExtras) || 0;
                const baseHora = (baseTurno / 12) * 1.35; // Hora extra con recargo
                const valorHorasExtras = baseHora * horasExtras;

                // Valor turno = recargo (diferencia) + horas extras con recargo
                const valorTurnoTotal = (turnoRecargado - baseTurno) + valorHorasExtras;

                setDatosAdicional((d) => ({
                    ...d,
                    valorTurno: parseFloat(valorTurnoTotal.toFixed(2)),
                    fueraStgo: true,
                }));
            } else {
                // Desactivando "Fuera de Santiago"
                // Recalcular solo con horas extras sin recargo
                const horasExtras = parseFloat(datosAdicional.horasExtras) || 0;
                const baseTurno = row.valorTurnoBase || 0;
                const baseHora = baseTurno / 12; // Hora extra normal
                const valorHorasExtras = baseHora * horasExtras;

                setDatosAdicional((d) => ({
                    ...d,
                    valorTurno: parseFloat(valorHorasExtras.toFixed(2)),
                    valorColacion: 0,
                    valorMovilizacion: 0,
                    valorOtro: 0,
                    fueraStgo: false,
                }));
            }

            return nuevoEstado;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (!selectedCobro) {
            gdAlertify.notiError("Debe seleccionar un tipo de cobro/descuento.");
            setIsSubmitting(false);
            return;
        }
        if (tipoReemplazo === "rango") {
            if (!fechaInicio || !fechaFin) {
                gdAlertify.notiError("Debe ingresar ambas fechas");
                return;
            }
            if (fechaInicio > fechaFin) {
                gdAlertify.notiError("Fecha de inicio no puede ser mayor que la de fin");
                return;
            }
            if (fechaInicio < periodoDesde) {
                gdAlertify.notiError(`Fechas deben ser mayor a ${formatDate(periodoDesde)}`);
                return;
            }
        }

        gdAlertify.confirm({
            title: datosAdicional.idAdicional ? "Editar Adicional" : "Confirmar Adicional",
            message: datosAdicional.idAdicional ? "¿Está seguro de actualizar el adicional?" : "¿Está seguro de crear el adicional?",
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const payload = {
                        ...datosAdicional,
                        idAdicional: datosAdicional.idAdicional || 0, // Asegurar que viaja
                        horasExtras: Number(datosAdicional.horasExtras) || 0,
                        valorTurno: Number(datosAdicional.valorTurno) || 0,
                        valorColacion: Number(datosAdicional.valorColacion) || 0,
                        valorMovilizacion: Number(datosAdicional.valorMovilizacion) || 0,
                        valorOtro: Number(datosAdicional.valorOtro) || 0,
                        tipoReemplazo,
                        fechaInicio: tipoReemplazo === "rango" ? fechaInicio : null,
                        fechaFin: tipoReemplazo === "rango" ? fechaFin : null,
                        tipoTurno,
                        es_apoyo: row.es_apoyo,
                        auxiliarID: auxiliarTercero ? auxiliarTercero.id : row.auxiliarID, // usa auxiliar nuevo si hay
                        auxiliar_defecto: !auxiliarTercero // true si usa auxiliar por defecto, false si cambió
                    };

                    const response = await axiosInstance.post("/acuerdo-mutuo/adicional", payload);

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message);
                        onConfirm();
                        onClose();
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                } catch (error) {
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                    setIsSubmitting(false);
                }
            },
            onCancel: () => {
                gdAlertify.notify("Envío cancelado", "error");
                setIsSubmitting(false);
            },
        });
    };

    if (!isOpen || !row) return null;

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {datosAdicional.idAdicional ? "Editar Adicional" : "Ingreso Adicional"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="modal-body">
                                <InfoHeader row={row} />

                                <label className="form-label">Cobros / Descuentos</label>
                                <Select
                                    options={auxiliares}
                                    onChange={handleAuxiliar}
                                    id="tipo_cobro"
                                    placeholder="Seleccione cobro/descuento"
                                    value={selectedCobro}
                                    isClearable
                                    isDisabled={isSubmitting}
                                />

                                {/* 🔍 Buscar auxiliar opcional */}
                                <div className="mt-3">
                                    <BuscarAuxiliar
                                        onSelect={(aux) => setAuxiliarTercero(aux)}
                                        titulo="Asociar adicional a otro auxiliar (opcional)"
                                    />
                                    {auxiliarTercero && (
                                        <div className="alert alert-info mt-2 p-2">
                                            <strong>Auxiliar seleccionado:</strong>{" "}
                                            {auxiliarTercero.nombre} {auxiliarTercero.apellidoPaterno} {auxiliarTercero.apellidoMaterno}
                                        </div>
                                    )}
                                </div>

                                <div className="row g-3 mt-3">
                                    <div className="col-md-12">
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="fueraStgoSwitch"
                                                checked={fueraStgo}
                                                onChange={toggleFueraStgo}
                                                disabled={isSubmitting}
                                            />
                                            <label className="form-check-label" htmlFor="fueraStgoSwitch">
                                                ¿Fuera de Santiago? (+35 % sobre valor completo)
                                            </label>
                                        </div>
                                        {fueraStgo && (
                                            <div className="text-success mt-1">
                                                Se aplica un recargo del 35 % al valor completo del turno y otros.
                                            </div>
                                        )}
                                    </div>

                                    {/* Horas Extras - siempre visible */}
                                    <div className="col-md-12">
                                        <label className="form-label">Horas Extras</label>
                                        <input
                                            type="number"
                                            name="horasExtras"
                                            className="form-control"
                                            value={datosAdicional.horasExtras}
                                            onChange={handleChange}
                                            min={0}
                                            disabled={isSubmitting}
                                        />
                                    </div>

                                    {/* Checkbox Valor Turno cuando está fuera de Santiago */}

                                    {/* Valor Turno calculado */}
                                    <div className="col-md-3">
                                        <label className="form-label">
                                            Valor Turno {fueraStgo && <small className="text-muted">(calculado)</small>}
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text">$</span>
                                            <input
                                                type="number"
                                                name="valorTurno"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={datosAdicional.valorTurno}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label">
                                            Colación {fueraStgo && (<small className="text-muted">(35 % recargo)</small>)}
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text">$</span>
                                            <input
                                                type="number"
                                                name="valorColacion"
                                                className="form-control"
                                                value={datosAdicional.valorColacion}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label">
                                            Movilización {fueraStgo && (<small className="text-muted">(35 % recargo)</small>)}
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text">$</span>
                                            <input
                                                type="number"
                                                name="valorMovilizacion"
                                                className="form-control"
                                                value={datosAdicional.valorMovilizacion}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label">
                                            Otro {fueraStgo && (<small className="text-muted">(35 % recargo)</small>)}
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text">$</span>
                                            <input
                                                type="number"
                                                name="valorOtro"
                                                className="form-control"
                                                value={datosAdicional.valorOtro}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3 mt-3">
                                    <label className="form-label">Tipo de Adicional:</label>
                                    <select
                                        className="form-select"
                                        value={tipoReemplazo}
                                        onChange={(e) => setTipoReemplazo(e.target.value)}
                                        disabled={isSubmitting}
                                    >
                                        <option value="individual">
                                            Fecha Seleccionada ({formatDate(row.fecha)} - {row.tipo == 'day' ? 'Día' : 'Noche'})
                                        </option>
                                        {!esApoyo && (<option value="rango">Rango de fechas</option>)}
                                    </select>
                                </div>

                                {tipoReemplazo === "rango" && (
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Inicio:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaInicio}
                                                onChange={(e) => setFechaInicio(e.target.value)}
                                                min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Fin:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaFin}
                                                onChange={(e) => setFechaFin(e.target.value)}
                                                min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                        <p className="text-muted mt-2">
                                            Periodo válido: {formatDate(periodoDesde)} al {formatDate(periodoHasta)}
                                        </p>
                                    </div>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Tipo Turno:</label>
                                    <select
                                        className="form-select"
                                        value={tipoTurno}
                                        onChange={(e) => setTipoTurno(e.target.value)}
                                        disabled={isSubmitting}
                                    >
                                        <option value={row.tipo == 'day' ? 1 : 2}>
                                            Actual - {row.tipo == 'day' ? 'Día' : 'Noche'}
                                        </option>
                                        {!esApoyo && (<option value="3">Día y noche</option>)}
                                    </select>
                                </div>

                                <div className="mt-3">
                                    <label className="form-label">Motivo Adicional</label>
                                    <textarea
                                        name="motivoAdicional"
                                        className="form-control"
                                        rows={2}
                                        value={datosAdicional.motivoAdicional}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-success"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Enviando..." : (datosAdicional.idAdicional ? "Actualizar" : "Guardar")}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};


const ModalAdicionales = ({ isOpen, onClose, row, onEliminar, onEditar }) => {
    if (!isOpen || !row || !row.adicionales) return null;

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Lista de Adicionales</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>

                        <div className="modal-body">
                            <InfoHeader row={row} />

                            {row.adicionales.length > 0 ? (
                                <table className="table table-sm table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Responsable</th>
                                            <th>Tipo Cobro</th>
                                            <th>Tipo</th>
                                            <th>Valor</th>
                                            <th>Colación</th>
                                            <th>Movilización</th>
                                            <th>Otro</th>
                                            <th>Horas Extras</th>
                                            <th>Fuera Stgo</th>
                                            <th>Motivo</th>
                                            <th></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {row.adicionales.map((item) => (
                                            <tr key={item.adicionalID}>
                                                <td>{item.fechaAdicional}</td>
                                                <td>{item.auxiliarNombre || '-'}</td>
                                                <td>
                                                    {item.auxiliarRemplazoID === 1 ? "Paga SK" :
                                                     item.auxiliarRemplazoID === 2 ? "Cobrar al Paciente" : "-"}
                                                </td>
                                                <td>{item.tipo_fecha === 1 ? "Día" : "Noche"}</td>
                                                <td>${formatMoney(item.valorTurno)}</td>
                                                <td>${formatMoney(item.valorColacion)}</td>
                                                <td>${formatMoney(item.valorMovilizacion)}</td>
                                                <td>${formatMoney(item.valorOtro)}</td>

                                                {/* NUEVO: Horas extra */}
                                                <td>{item.horasExtras ?? 0}</td>

                                                {/* NUEVO: Fuera Stgo */}
                                                <td className={item.fueraStgo === 1 ? "text-success fw-bold" : ""}>
                                                    {item.fueraStgo === 1 ? "Sí" : "No"}
                                                </td>

                                                <td>{item.motivoAdicional}</td>

                                                <td>
                                                    <div className="btn-group" role="group">
                                                        <button
                                                            className="btn btn-sm btn-warning"
                                                            onClick={() => onEditar(item)}
                                                            title="Editar"
                                                        >
                                                            <i className="bi bi-pencil"></i>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => onEliminar(item.adicionalID)}
                                                            title="Eliminar"
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="text-muted">No hay adicionales registrados.</div>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



const ModalValorAdicional = ({ isOpen, onClose, onConfirm, row }) => {
    const [observacion, setObservacion] = useState("");
    const [valor, setValor] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isOpen && row) {
            setValor(0);
            setObservacion("");
        }
    }, [isOpen, row]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        gdAlertify.confirm({
            title: "Confirmar Valor Otro",
            message: '¿Está seguro de registrar este valor otro?',
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const data = {
                        pacienteID: row.pacienteID,
                        auxiliarID: row.auxiliarID,
                        fecha: row.fecha,
                        periodo: row.tipo,
                        valor,
                        observacion,
                    };

                    const response = await axiosInstance.post("/acuerdo-mutuo/valor-otro", data);

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message);
                        onConfirm();
                        onClose();
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                } catch (error) {
                    gdAlertify.notiError("Error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                }
            },
            onCancel: () => {
                gdAlertify.notify("Cancelado", "error");
            },
        });
    };

    if (!isOpen || !row) return null;

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Valor Otro</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <InfoHeader row={row} />

                            <label className="form-label">Valor Otro</label>
                            <input
                                type="number"
                                className="form-control mb-3"
                                value={valor}
                                onChange={(e) => setValor(Number(e.target.value))}
                            />

                            <label className="form-label">Observación</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={observacion}
                                onChange={(e) => setObservacion(e.target.value)}
                            />
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                            <button className="btn btn-primary" onClick={handleSubmit}>Guardar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const EliminarTurnoModal = ({ isOpen, onClose, onConfirm, row, periodo }) => {
    const [tipoEliminacion, setTipoEliminacion] = useState("individual"); // individual | rango
    const [tipoTurno, setTipoTurno] = useState("1");                     // 1 día | 2 noche | 3 ambos
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");

    useEffect(() => {
        if (!periodo) return;
        const [anioStr, mesStr] = periodo.split("-");
        const mes = parseInt(mesStr, 10) - 1;
        const anio = parseInt(anioStr, 10);
        const desde = new Date(anio, mes - 1, 26);
        const hasta = new Date(anio, mes, 25);
        setPeriodoDesde(desde.toISOString().split("T")[0]);
        setPeriodoHasta(hasta.toISOString().split("T")[0]);
    }, [periodo]);

    useEffect(() => {
        if (isOpen && row) {
            setTipoEliminacion("individual");
            setFechaInicio(row.fecha || "");
            setFechaFin("");
            // Determina tipoTurno inicial:
            let initialTipo = "1";
            if (row?.tipo === "day" || row?.turno === "1") initialTipo = "1";
            else if (row?.tipo === "night" || row?.turno === "2") initialTipo = "2";
            else if (["3", "daynight"].includes(String(row?.tipoTurno))) initialTipo = "3";
            setTipoTurno(initialTipo);
        }
    }, [isOpen, row]);

    if (!isOpen || !row) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validaciones
        if (tipoEliminacion === "rango") {
            if (!fechaInicio || !fechaFin) {
                gdAlertify.notiError("Debe ingresar fechas inicio y fin");
                return;
            }
            if (fechaInicio > fechaFin) {
                gdAlertify.notiError("Fecha inicio no puede ser mayor que la de fin");
                return;
            }
            if (fechaInicio < periodoDesde) {
                gdAlertify.notiError(`Fechas deben ser mayor a ${formatDate(periodoDesde)}`);
                return;
            }
        }

        gdAlertify.confirm({
            title: "Eliminar Turno(s)",
            message: "¿Estás seguro? Esta acción no se puede deshacer.",
            onConfirm: async () => {
                setIsSubmitting(true);
                gdAlertify.showLoader();
                try {
                    const payload = {
                        pacienteID: row.pacienteID,
                        auxiliarID: row.auxiliarID,
                        // Para compatibilidad con backend actual
                        data: row,
                        tipoEliminacion,                   // "individual" | "rango"
                        fechaInicio: tipoEliminacion === "rango" ? fechaInicio : row.fecha,
                        fechaFin: tipoEliminacion === "rango" ? fechaFin : row.fecha,
                        tipoTurno,                   // "1","2","3"
                        es_apoyo: row.es_apoyo,
                    };

                    const resp = await axiosInstance.post("/turnos/eliminar", payload);

                    if (!resp.data.error) {
                        gdAlertify.notiSuccess(resp.data.message || "Turno(s) eliminado(s)");
                        onConfirm();          // refrescar tabla
                        onClose();
                    } else {
                        gdAlertify.notiError(resp.data.message || "No se pudo eliminar");
                    }
                } catch (err) {
                    gdAlertify.notiError("Error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                    setIsSubmitting(false);
                }
            },
            onCancel: () => gdAlertify.notify("Cancelado", "error"),
        });
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Eliminar Turno(s)</h5>
                                <button type="button" className="btn-close" onClick={onClose} disabled={isSubmitting} />
                            </div>
                            <div className="modal-body">
                                <InfoHeader row={row} />

                                <div className="mb-3">
                                    <label className="form-label">Tipo de eliminación:</label>
                                    <select
                                        className="form-select"
                                        value={tipoEliminacion}
                                        onChange={(e) => setTipoEliminacion(e.target.value)}
                                        disabled={isSubmitting}
                                    >
                                        <option value="individual">
                                            Fecha Seleccionada ({formatDate(row.fecha)} - {row.turno === "1" ? "Día" : "Noche"})
                                        </option>
                                        <option value="rango">Rango de fechas</option>
                                    </select>
                                </div>

                                {tipoEliminacion === "rango" && (
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Inicio:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaInicio}
                                                onChange={(e) => setFechaInicio(e.target.value)}
                                                min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Fin:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaFin}
                                                onChange={(e) => setFechaFin(e.target.value)}
                                                min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                        <p className="text-muted mt-2">
                                            Periodo válido: {formatDate(periodoDesde)} al {formatDate(periodoHasta)}
                                        </p>
                                    </div>
                                )}

                                <div className="mb-3">
                                    <label className="form-label">Tipo Turno a eliminar:</label>
                                    <select
                                        className="form-select"
                                        value={tipoTurno}
                                        onChange={(e) => setTipoTurno(e.target.value)}
                                        disabled={isSubmitting}
                                    >
                                        <option value={row.turno === "1" ? 1 : 2}>
                                            Actual - {row.turno === "1" ? "Día" : "Noche"}
                                        </option>
                                        <option value="3">Día y noche</option>
                                    </select>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isSubmitting}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-danger" disabled={isSubmitting}>
                                    {isSubmitting ? "Eliminando..." : "Eliminar"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

// Modal para eliminar nota(s) basada en rango o fecha individual
const EliminarNotaModal = ({ isOpen, onClose, onConfirm, row, periodo }) => {
    const [tipoEliminacion, setTipoEliminacion] = useState("individual"); // individual | rango
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");

    // Calcular límites del período (26 al 25)
    useEffect(() => {
        if (!periodo) return;
        const [anioStr, mesStr] = periodo.split("-");
        const anio = parseInt(anioStr, 10);
        const mes = parseInt(mesStr, 10);
        const desde = new Date(anio, mes - 1, 26);
        const hasta = new Date(anio, mes, 25);
        setPeriodoDesde(desde.toISOString().split("T")[0]);
        setPeriodoHasta(hasta.toISOString().split("T")[0]);
    }, [periodo]);

    useEffect(() => {
        if (isOpen && row) {
            setTipoEliminacion("individual");
            setFechaInicio(row.fecha || "");
            setFechaFin("");
        }
    }, [isOpen, row]);

    if (!isOpen || !row) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (tipoEliminacion === "rango") {
            if (!fechaInicio || !fechaFin) {
                gdAlertify.notiError("Debe ingresar fechas inicio y fin");
                return;
            }
            if (fechaInicio > fechaFin) {
                gdAlertify.notiError("Fecha inicio no puede ser mayor que la de fin");
                return;
            }
            // if (fechaInicio < periodoDesde) {
            //     gdAlertify.notiError(`Fechas deben ser mayor a ${formatDate(periodoDesde)}`);
            //     return;
            // }
        }

        gdAlertify.confirm({
            title: "Eliminar Nota(s)",
            message: "¿Está seguro de eliminar la(s) nota(s)? Esta acción no se puede deshacer.",
            onConfirm: async () => {
                setIsSubmitting(true);
                gdAlertify.showLoader();
                try {
                    // Reutilizamos el endpoint de notas enviando nota vacía
                    const payload = {
                        data: row,
                        nota: "",
                        tipoNota: tipoEliminacion, // "individual" | "rango"
                        fechaInicio: tipoEliminacion === "rango" ? fechaInicio : row.fecha,
                        fechaFin: tipoEliminacion === "rango" ? fechaFin : row.fecha,
                    };

                    const resp = await axiosInstance.post("/turnos/nota", payload);

                    if (!resp.data.error) {
                        gdAlertify.notiSuccess(resp.data.message || "Nota(s) eliminada(s)");
                        onConfirm();
                        onClose();
                    } else {
                        gdAlertify.notiError(resp.data.message || "No se pudo eliminar la nota");
                    }
                } catch (err) {
                    gdAlertify.notiError("Error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                    setIsSubmitting(false);
                }
            },
        });
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Eliminar Nota(s)</h5>
                                <button type="button" className="btn-close" onClick={onClose} disabled={isSubmitting} />
                            </div>
                            <div className="modal-body">
                                <InfoHeader row={row} />

                                <div className="mb-3 mt-2">
                                    <label className="form-label">Tipo de eliminación:</label>
                                    <select
                                        className="form-select"
                                        value={tipoEliminacion}
                                        onChange={(e) => setTipoEliminacion(e.target.value)}
                                        disabled={isSubmitting}
                                    >
                                        <option value="individual">Fecha seleccionada ({formatDate(row.fecha)})</option>
                                        <option value="rango">Rango de fechas</option>
                                    </select>
                                </div>

                                {tipoEliminacion === "rango" && (
                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Inicio:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaInicio}
                                                onChange={(e) => setFechaInicio(e.target.value)}
                                                // min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha Fin:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaFin}
                                                onChange={(e) => setFechaFin(e.target.value)}
                                                // min={periodoDesde}
                                                disabled={isSubmitting}
                                            />
                                        </div>
                                        <p className="text-muted mt-2">
                                            Periodo válido: {formatDate(periodoDesde)} al {formatDate(periodoHasta)}
                                        </p>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isSubmitting}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-danger" disabled={isSubmitting}>
                                    {isSubmitting ? "Eliminando..." : "Eliminar"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

const ObservationAuxiliarModal = ({ isOpen, onClose, auxiliarID, auxiliarNombre }) => {
    const [observation, setObservation] = useState("");
    const [observaciones, setObservaciones] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && auxiliarID) {
            cargarObservaciones();
        }
    }, [isOpen, auxiliarID]);

    const cargarObservaciones = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get("/auxiliar/historial", {
                params: { idAuxiliar: auxiliarID }
            });
            if (!response.data.error) {
                setObservaciones(response.data.data.observaciones || []);
            }
        } catch (error) {
            console.error("Error al cargar historial:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        if (!observation.trim()) {
            gdAlertify.notiError("Debe ingresar una observación");
            return;
        }

        try {
            const response = await axiosInstance.post("/auxiliar/observaciones/guardar", {
                auxiliarID,
                observacion: observation,
            });

            if (!response.data.error) {
                gdAlertify.notiSuccess(response.data.message);
                setObservation("");
                cargarObservaciones(); // Recargar lista
            } else {
                gdAlertify.notiError(response.data.message);
            }
        } catch (error) {
            gdAlertify.notiError("Error al guardar la observación");
        }
    };


    if (!isOpen) return null;

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Observaciones: {auxiliarNombre}</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-4">
                                <h6>Agregar Nueva Observación</h6>
                                <textarea
                                    className="form-control mb-2"
                                    rows="3"
                                    value={observation}
                                    onChange={(e) => setObservation(e.target.value)}
                                    placeholder="Escriba aquí la observación..."
                                />
                                <button className="btn btn-primary btn-sm" onClick={handleSave}>
                                    Guardar Observación
                                </button>
                            </div>

                            <hr />

                            <h6>Historial de Observaciones</h6>
                            {loading ? (
                                <p>Cargando historial...</p>
                            ) : (
                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    <table className="table table-sm table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '20%' }}>Fecha</th>
                                                <th>Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {observaciones.length > 0 ? (
                                                observaciones.map((obs, index) => (
                                                    <tr key={index}>
                                                        <td>{formatDate(obs.fecha)}</td>
                                                        <td>{obs.observacion}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2" className="text-center text-muted">
                                                        No hay observaciones registradas.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

function useCustomMonth() {
    const today = new Date();
    const day = today.getDate();

    // Si el día es >= 26, pasamos al siguiente mes
    if (day >= 26) {
        today.setDate(1); // Evitar desbordamiento si el próximo mes tiene menos días (ej: 31 de marzo -> 1 de mayo)
        today.setMonth(today.getMonth() + 1);
    }

    // Lo devolvemos en formato YYYY-MM
    return today.toISOString().slice(0, 7);
}

const EliminarAdicionalesMasivoModal = ({ isOpen, onClose, onConfirm, periodo, pacienteID, pacienteNombre, rowFecha }) => {
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [turno, setTurno] = useState("ambos"); // "1" = Día, "2" = Noche, "ambos" = Ambos
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");

    // Calcular fechas límites a partir de "periodo" (formato "YYYY-MM")
    useEffect(() => {
        if (!periodo) return;

        const [anioStr, mesStr] = periodo.split("-");
        const mes = parseInt(mesStr, 10) - 1; // 0-based
        const anio = parseInt(anioStr, 10);

        // Desde: día 26 del mes anterior
        const desde = new Date(anio, mes - 1, 26);
        // Hasta: día 25 del mes actual
        const hasta = new Date(anio, mes, 25);

        setPeriodoDesde(desde.toISOString().split("T")[0]);
        setPeriodoHasta(hasta.toISOString().split("T")[0]);
    }, [periodo]);

    // Inicializar con la fecha del turno seleccionado
    useEffect(() => {
        if (!rowFecha) return;

        // Inicializar ambas fechas con la fecha del turno seleccionado
        setFechaInicio(rowFecha);
        setFechaFin(rowFecha);
        setTurno("ambos");
    }, [rowFecha, isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!fechaInicio || !fechaFin) {
            gdAlertify.notiError("Debe ingresar ambas fechas");
            return;
        }
        if (fechaInicio > fechaFin) {
            gdAlertify.notiError("Fecha de inicio no puede ser mayor que la de fin");
            return;
        }

        const turnoTexto = turno === "1" ? "Día" : turno === "2" ? "Noche" : "Ambos turnos";
        const rangoTexto = fechaInicio === fechaFin
            ? `el ${formatDate(fechaInicio)}`
            : `entre ${formatDate(fechaInicio)} y ${formatDate(fechaFin)}`;

        gdAlertify.confirm({
            title: "Eliminar Adicionales",
            message: `⚠️ ¿Está seguro de eliminar TODOS los adicionales de ${pacienteNombre} ${rangoTexto} (${turnoTexto})? Esta acción no se puede deshacer.`,
            onConfirm: async () => {
                setIsSubmitting(true);
                gdAlertify.showLoader();
                try {
                    const payload = {
                        pacienteID,
                        fechaInicio,
                        fechaFin,
                        turno, // "1", "2", o "ambos"
                    };

                    const resp = await axiosInstance.post("/acuerdo-mutuo/adicional/eliminar-masivo", payload);

                    if (!resp.data.error) {
                        gdAlertify.notiSuccess(resp.data.message || "Adicionales eliminados correctamente");
                        onConfirm();
                        onClose();
                    } else {
                        gdAlertify.notiError(resp.data.message || "No se pudieron eliminar los adicionales");
                    }
                } catch (err) {
                    gdAlertify.notiError("Error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                    setIsSubmitting(false);
                }
            },
            onCancel: () => gdAlertify.notify("Cancelado", "error"),
        });
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Eliminar Adicionales - {pacienteNombre}</h5>
                                <button type="button" className="btn-close" onClick={onClose} disabled={isSubmitting} />
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-warning">
                                    <i className="bi bi-exclamation-triangle me-2"></i>
                                    Esta acción eliminará TODOS los adicionales de <strong>{pacienteNombre}</strong> en el rango y turno seleccionado.
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Turno:</label>
                                    <select
                                        className="form-select"
                                        value={turno}
                                        onChange={(e) => setTurno(e.target.value)}
                                        disabled={isSubmitting}
                                    >
                                        <option value="ambos">Ambos (Día y Noche)</option>
                                        <option value="1">Día</option>
                                        <option value="2">Noche</option>
                                    </select>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Fecha Inicio:</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fechaInicio}
                                            onChange={(e) => setFechaInicio(e.target.value)}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Fecha Fin:</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fechaFin}
                                            onChange={(e) => setFechaFin(e.target.value)}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </div>

                                <p className="text-muted small">
                                    <i className="bi bi-info-circle me-1"></i>
                                    Por defecto se eliminan los adicionales del día seleccionado. Puede modificar las fechas para un rango mayor.
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isSubmitting}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-danger" disabled={isSubmitting}>
                                    {isSubmitting ? "Eliminando..." : "Eliminar Adicionales"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

const CalendarioTurnos = () => {
    const [searchPatient, setSearchPatient] = useState([]);
    const [startMonth, setStartMonth] = useState(useCustomMonth()); // Establecer el mes actual
    const [turnos, setTurnos] = useState([]);

    // Estados para el modal de recordatorios
    const [isRecordatoriosOpen, setIsRecordatoriosOpen] = useState(false);
    const [recordatorioPacienteId, setRecordatorioPacienteId] = useState(null);
    const [recordatorioPacienteNombre, setRecordatorioPacienteNombre] = useState("");

    const [isVacacionesOpen, setIsVacacionesOpen] = useState(false);
    const [auxiliarForVacaciones, setAuxiliarForVacaciones] = useState(null);
    const [isNoEnviarOpen, setIsNoEnviarOpen] = useState(false);
    const [noEnviarContext, setNoEnviarContext] = useState(null);

    const handleOpenRecordatorios = (pacienteId, pacienteNombre) => {
        setRecordatorioPacienteId(pacienteId);
        setRecordatorioPacienteNombre(pacienteNombre);
        setIsRecordatoriosOpen(true);
    };

    const handleOpenNoEnviar = (row) => {
        const auxiliarActual = getTurnoAuxiliarActualInfo(row);

        if (!auxiliarActual.id) {
            gdAlertify.notiError("No hay un auxiliar asignado a este turno.");
            return;
        }

        setSelectedRow(row);
        setNoEnviarContext({
            auxiliarID: auxiliarActual.id,
            nombreAuxiliar: auxiliarActual.nombre || "Auxiliar",
            pacienteID: row?.pacienteID || null,
            pacienteNombre: row?.pacienteNombre || "",
        });
        setIsNoEnviarOpen(true);
    };

    const [isReemplazoOpen, setIsReemplazoOpen] = useState(false);
    const [isAdicionalOpen, setIsAdicionalOpen] = useState(false);
    const [isNotaOpen, setIsNotaOpen] = useState(false);
    const [isEliminarNotaOpen, setIsEliminarNotaOpen] = useState(false);
    const [isValorAdicionalOpen, setIsValorAdicionalOpen] = useState(false);
    const [isAdicionalesModalOpen, setIsAdicionalesModalOpen] = useState(false);
    const [isEliminarAdicionalesMasivoOpen, setIsEliminarAdicionalesMasivoOpen] = useState(false);
    const [isObservationModalOpen, setIsObservationModalOpen] = useState(false);
    const [isColorOpen, setIsColorOpen] = useState(false);

    const [selectedRow, setSelectedRow] = useState(null);
    const [mostrarExtendido, setMostrarExtendido] = useState(false);
    const reemplazarAuxiliar = async (row) => {
        setIsReemplazoOpen(true); // Abre el modal
    };

    const ingresarAdicional = async (idPaciente) => {
        setIsAdicionalOpen(true); // Abre el modal
    }

    const ingresarNota = async (idPaciente) => {
        setIsNotaOpen(true); // Abre el modal
    };

    const cambiarColor = (row) => {
        setSelectedRow(row);
        setIsColorOpen(true);
    };

    const eliminarNota = (row) => {
        setSelectedRow(row);
        setIsEliminarNotaOpen(true);
    };

    // const eliminarTurno = async (row) => {
    //     const { pacienteNombre, pacienteRut, auxiliarNombre, fecha, turno } = row;
    //     const labelTurno = turno === "1" ? "Día" : "Noche";
    //     gdAlertify.confirm({
    //         title: "Eliminar Turno",
    //         message: `¿Está seguro de eliminar turno al paciente ${pacienteNombre} de ${auxiliarNombre} el ${fecha}-${labelTurno}?`,
    //         onConfirm: async () => {
    //             gdAlertify.showLoader()
    //             try {
    //                 const response = await axiosInstance.post("/turnos/eliminar", row)

    //                 if (!response.data.error) {
    //                     gdAlertify.notiSuccess(response.data.message)
    //                     obtenerTurnos(startMonth, searchPatient)
    //                 } else {
    //                     gdAlertify.notiError(response.data.message)
    //                 }
    //                 gdAlertify.hideLoader()
    //             } catch (error) {
    //                 gdAlertify.hideLoader()
    //                 gdAlertify.notiError("Ocurrió un error al conectar con el servidor.")
    //             }
    //         },
    //         onCancel: () => {
    //             gdAlertify.notify("Envío cancelado", "error")
    //         },
    //     })
    // };
    const [isEliminarOpen, setIsEliminarOpen] = useState(false);

    // Reemplaza la función eliminarTurno actual
    const eliminarTurno = (row) => {
        setSelectedRow(row);
        setIsEliminarOpen(true);
    };

    // nuevos estados
    const [isActualizarValoresOpen, setIsActualizarValoresOpen] = useState(false);

    // handler
    const actualizarValores = (row) => {
        setSelectedRow(row);
        setIsActualizarValoresOpen(true);
    };

    const handleOpenObservation = (row) => {
        setSelectedRow(row);
        setIsObservationModalOpen(true);
    };

    const obtenerTurnos = async (periodo, paciente) => {
        try {
            gdAlertify.showLoader()
            const params = { periodo };
            if (paciente) {
                params.pacienteID = paciente.id;
            }

            const response = await axiosInstance.get("/turnos/lista", {
                params,
            });

            if (response.data && !response.data.error) {
                const turnosProcesados = response.data.turnos.map(t => ({
                    ...t,
                    valorTotal: (t.valorTurnoRt || 0) + (t.valorColacionRt || 0) + (t.valorLocomocionRt || 0) + (t.valorOtroRt || 0)
                }));
                setTurnos(turnosProcesados);
            } else {
                if (typeof gdAlertify !== "undefined") {
                    gdAlertify.notiError("No se pudieron cargar los turnos.");
                } else {
                    console.error("gdAlertify is not defined");
                }
            }
            gdAlertify.hideLoader()
        } catch (error) {
            console.error(error);
            if (typeof gdAlertify !== "undefined") {
                gdAlertify.notiError("Ocurrió un error al cargar los turnos.");
            } else {
                console.error("gdAlertify is not defined");
            }
            gdAlertify.hideLoader()
        }
    };

    useEffect(() => {
        obtenerTurnos(startMonth, searchPatient); // Obtener los turnos con los filtros actuales
    }, [startMonth, searchPatient]); // Solo vuelve a ejecutarse cuando el mes o paciente cambian

    const handleMonthChange = (e) => {
        setStartMonth(e.target.value); // Cambiar el mes seleccionado
    };

    const handleSeleccionPaciente = (paciente) => {
        setSearchPatient(paciente); // Actualizar el paciente seleccionado
    };

    const getDayOfWeek = (dateString) => {
        const days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
        const date = new Date(dateString);
        return days[date.getDay()];
    };

    const colorPalette = [
        "#C62828", "#1565C0", "#2E7D32", "#F9A825", "#6A1B9A",
        "#00897B", "#FF8F00", "#4527A0", "#0277BD", "#5D4037",
        "#AD1457", "#283593", "#558B2F", "#D84315", "#303F9F",
        "#FF6F00", "#455A64", "#9E9D24", "#4E342E", "#00838F"
    ];

    const nombreColorMap = {};
    let nextColorIndex = 0;

    const getColorForNombre = (nombre) => {
        if (nextColorIndex == 20) {
            nextColorIndex = 0;
        }

        if (!nombreColorMap[nombre]) {
            nombreColorMap[nombre] = colorPalette[nextColorIndex % colorPalette.length];
            nextColorIndex++;
        }
        return nombreColorMap[nombre];
    };

    const AuxiliarNombreCell = React.memo(({ row }) => {
        if (row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0) {
            return (
                <>
                    {row.reemplazoNombre}
                </>
            );
        }
        return <>{row.auxiliarNombre}</>;
    });

    const AuxiliarRutCell = React.memo(({ row }) => {
        if (row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0) {
            return (
                <>
                    {row.reemplazoRut}
                </>
            );
        }
        return <>{row.auxiliarRut}</>;
    });

    const NotasCell = React.memo(({ row }) => {
        let nota = row.notes || "";
        const multiAdicional = row.adicionales?.length > 1;

        if (row.reemplazoNombre) {
            nota += ` (Reemplazo) `;
        }

        // Agregar notas internas con separador
        if (row.notas_internas) {
            nota += (nota ? " - " : "") + row.notas_internas;
        }

        if (row.adicionales?.length > 0) {
            row.adicionales.forEach(item => {
                nota += ` - Adicional a ${item.auxiliarNombre} `;

                const addIf = (val, label) => {
                    // Solo agrega si es un número diferente de 0
                    if (val !== null && val !== undefined && Number(val) !== 0) {
                        nota += ` ${label} $${formatMoney(val)}`;
                    }
                };

                addIf(item.valorTurno, "turno");
                addIf(item.valorColacion, "colación");
                addIf(item.valorMovilizacion, "movilización");
                addIf(item.valorOtro, "otro");

                if (item.motivoAdicional) {
                    nota += ` motivo ${item.motivoAdicional}`;
                }
            });
        }

        if (multiAdicional) {
            return (
                <div className="bg-row-rojo-claro px-1 rounded" style={{ height: '100%', width: '100%' }}>
                    {nota}
                </div>
            );
        }

        return nota;
    });

    const NotasText = (row) => {
        let nota = row.notes || "";

        if (row.reemplazoNombre) {
            nota += ` (Reemplazo) `;
        }

        // Agregar notas internas con separador
        if (row.notas_internas) {
            nota += (nota ? " - " : "") + row.notas_internas;
        }

        if (row.adicionales?.length > 0) {
            row.adicionales.forEach(item => {
                nota += ` - Adicional a ${item.auxiliarNombre} `;

                const addIf = (val, label) => {
                    // Solo agrega si es un número diferente de 0
                    if (val !== null && val !== undefined && Number(val) !== 0) {
                        nota += ` ${label} $${formatMoney(val)}`;
                    }
                };

                addIf(item.valorTurno, "turno");
                addIf(item.valorColacion, "colación");
                addIf(item.valorMovilizacion, "movilización");
                addIf(item.valorOtro, "otro");

                if (item.motivoAdicional) {
                    nota += ` motivo ${item.motivoAdicional}`;
                }
            });
        }

        return nota;
    };

    const ActualizarValoresModal = ({ isOpen, onClose, onConfirm, row, periodo }) => {
        const [tipoActualizacion, setTipoActualizacion] = useState("individual"); // individual | rango
        const [fechaInicio, setFechaInicio] = useState("");
        const [fechaFin, setFechaFin] = useState("");
        const [periodoDesde, setPeriodoDesde] = useState("");
        const [periodoHasta, setPeriodoHasta] = useState("");
        const [valorTurno, setValorTurno] = useState("");
        const [valorColacion, setValorColacion] = useState("");
        const [valorLocomocion, setValorLocomocion] = useState("");
        const [valorOtro, setValorOtro] = useState("");
        const [isSubmitting, setIsSubmitting] = useState(false);


        // Inicializa los valores cuando se abre
        useEffect(() => {
            if (isOpen && row) {
                setValorTurno(row.valorTurnoRt || "");
                setValorColacion(row.valorColacionRt || "");
                setValorLocomocion(row.valorLocomocionRt || "");
                setValorOtro(row.valorOtroRt || "");
                setTipoActualizacion("individual");
                setFechaInicio(row.fecha || "");
                setFechaFin("");
            }
        }, [isOpen, row]);

        // Calcula el rango del período
        useEffect(() => {
            if (!periodo) return;
            const [anioStr, mesStr] = periodo.split("-");
            const anio = parseInt(anioStr, 10);
            const mes = parseInt(mesStr, 10);
            const desde = new Date(anio, mes - 1, 26);
            const hasta = new Date(anio, mes, 25);
            setPeriodoDesde(desde.toISOString().split("T")[0]);
            setPeriodoHasta(hasta.toISOString().split("T")[0]);
        }, [periodo]);

        if (!isOpen || !row) return null;

        const handleSubmit = (e) => {
            e.preventDefault();

            // Validaciones
            if (tipoActualizacion === "rango") {
                if (!fechaInicio || !fechaFin) {
                    gdAlertify.notiError("Debe ingresar fechas inicio y fin");
                    return;
                }
                if (fechaInicio > fechaFin) {
                    gdAlertify.notiError("Fecha inicio no puede ser mayor que la de fin");
                    return;
                }
                if (fechaInicio < periodoDesde) {
                    gdAlertify.notiError(`Las fechas deben ser mayores a ${periodoDesde}`);
                    return;
                }

                // Confirmación previa de rango
                gdAlertify.confirm({
                    title: "Confirmar Actualización por Rango",
                    message: `⚠️ Esta acción reemplazará todos los valores entre ${fechaInicio} y ${fechaFin}. ¿Desea continuar?`,
                    onConfirm: () => handleConfirmGuardar(true),
                    onCancel: () => gdAlertify.notify("Cancelado", "error"),
                });
            } else {
                handleConfirmGuardar(false);
            }
        };

        const handleConfirmGuardar = async (esRango) => {
            gdAlertify.confirm({
                title: "Actualizar Valores",
                message: esRango
                    ? "¿Está seguro de actualizar los valores en el rango seleccionado?"
                    : "¿Está seguro de actualizar los valores?",
                onConfirm: async () => {
                    setIsSubmitting(true);
                    gdAlertify.showLoader();
                    try {
                        const payload = {
                            pacienteID: row.pacienteID,
                            auxiliarID: row.auxiliarID,
                            fechaInicio: esRango ? fechaInicio : row.fecha,
                            fechaFin: esRango ? fechaFin : row.fecha,
                            periodo: row.tipo,
                            tipoActualizacion, // "individual" | "rango"
                            valorTurno,
                            valorColacion,
                            valorLocomocion,
                            valorOtro,
                            es_apoyo: row.es_apoyo,
                        };

                        const resp = await axiosInstance.post("/turnos/valores/actualiza", payload);

                        if (!resp.data.error) {
                            gdAlertify.notiSuccess(resp.data.message || "Valores actualizados");
                            onConfirm();
                            onClose();
                        } else {
                            gdAlertify.notiError(resp.data.message || "No se pudo actualizar");
                        }
                    } catch (err) {
                        gdAlertify.notiError("Error al conectar con el servidor.");
                    } finally {
                        gdAlertify.hideLoader();
                        setIsSubmitting(false);
                    }
                },
                onCancel: () => gdAlertify.notify("Cancelado", "error"),
            });
        };

        return (
            <>
                <div className="modal-backdrop fade show"></div>
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <form onSubmit={handleSubmit}>
                                <div className="modal-header">
                                    <h5 className="modal-title">Actualizar Valores</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={onClose}
                                        disabled={isSubmitting}
                                    />
                                </div>

                                <div className="modal-body">
                                    <InfoHeader row={row} />

                                    {/* Tipo de actualización */}
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Tipo de actualización</label>
                                        <select
                                            className="form-select"
                                            value={tipoActualizacion}
                                            onChange={(e) => setTipoActualizacion(e.target.value)}
                                            disabled={isSubmitting}
                                        >
                                            <option value="individual">
                                                Fecha seleccionada ({row.fecha})
                                            </option>
                                            <option value="rango">Rango de fechas</option>
                                        </select>
                                    </div>

                                    {/* Fechas si es rango */}
                                    {tipoActualizacion === "rango" && (
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label className="form-label">Fecha Inicio</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaInicio}
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                    min={periodoDesde}
                                                    disabled={isSubmitting}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Fecha Fin</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaFin}
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                    min={periodoDesde}
                                                    disabled={isSubmitting}
                                                />
                                            </div>
                                            <p className="text-muted mt-2">
                                                Periodo válido: {periodoDesde} al {periodoHasta}
                                            </p>
                                        </div>
                                    )}

                                    {/* Sección de valores */}
                                    <div className="row g-3">
                                        <div className="col-md-12 mb-3 text-center"><b>Se actualiza el valor para todos los turnos entre la fecha seleccionada</b></div>
                                        <div className="col-md-6">
                                            <div className="card p-3 shadow-sm border-0 bg-light">
                                                <label className="form-label mb-1 fw-semibold text-muted">Valor Turno</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorTurno}
                                                        onChange={(e) => setValorTurno(e.target.value)}
                                                        disabled={isSubmitting}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card p-3 shadow-sm border-0 bg-light">
                                                <label className="form-label mb-1 fw-semibold text-muted">Colación</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorColacion}
                                                        onChange={(e) => setValorColacion(e.target.value)}
                                                        disabled={isSubmitting}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card p-3 shadow-sm border-0 bg-light">
                                                <label className="form-label mb-1 fw-semibold text-muted">Locomoción</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorLocomocion}
                                                        onChange={(e) => setValorLocomocion(e.target.value)}
                                                        disabled={isSubmitting}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card p-3 shadow-sm border-0 bg-light">
                                                <label className="form-label mb-1 fw-semibold text-muted">Otros</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">$</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorOtro}
                                                        onChange={(e) => setValorOtro(e.target.value)}
                                                        disabled={isSubmitting}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={onClose}
                                        disabled={isSubmitting}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Guardando..." : "Guardar"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        );
    };



    const crearTurnoApoyo = async (row) => {
        gdAlertify.confirm({
            title: "Crear Turno Apoyo",
            message: `¿Deseas crear un turno de apoyo para el paciente ${row.pacienteNombre} el ${formatDate(row.fecha)} (${row.turno === "1" ? "Día" : "Noche"})?`,
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const payload = {
                        pacienteID: row.pacienteID,
                        fecha: row.fecha,
                        periodo: row.tipo // "day" o "night"
                    };

                    const response = await axiosInstance.post("/turnos/apoyo/crear", payload);

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message || "Turno de apoyo creado");
                        obtenerTurnos(startMonth, searchPatient);
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                } catch (error) {
                    gdAlertify.notiError("Error al crear el turno de apoyo.");
                } finally {
                    gdAlertify.hideLoader();
                }
            }
        });
    };

    const devolverReemplazo = (row) => {
        gdAlertify.confirm({
            title: "Devolver Reemplazo",
            message: `¿Está seguro de devolver el reemplazo del ${formatDate(row.fecha)} (${row.turno === "1" ? "Día" : "Noche"}) para ${row.pacienteNombre}?`,
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    // 🔁 Envía "row" tal cual al backend
                    const resp = await axiosInstance.post("/turnos/devolver", row);

                    if (!resp.data?.error) {
                        gdAlertify.notiSuccess(resp.data?.message || "Reemplazo devuelto correctamente.");
                        obtenerTurnos(startMonth, searchPatient); // refresca la tabla
                    } else {
                        gdAlertify.notiError(resp.data?.message || "No fue posible devolver el reemplazo.");
                    }
                } catch (err) {
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                }
            },
            onCancel: () => {
                gdAlertify.notify("Acción cancelada", "error");
            },
        });
    };


    // Definir las columnas para GdTable
    const columns = useMemo(() => {

        //
        // 🔵  Definición de columnas extendidas
        //
        const colRutPaciente = {
            title: "RUT Paciente",
            name: "pacienteRut",
            render: (row) => <b>{row.pacienteRut}</b>,
            width: 120,
        };

        const colRutAuxiliar = {
            title: "RUT Auxiliar",
            name: "auxiliarRut",
            render: (row) => <b><AuxiliarRutCell row={row} /></b>,
            width: 120,
        };

        //
        // 🔵  Definición de columnas base
        //
        const colNombrePaciente = {
            title: "Nombre Paciente",
            name: "pacienteNombre",
            render: (row) => {
                const color = getColorForNombre(row.pacienteNombre);
                // El campo se llama 'tiene_recordatorio'. 1 = Mostrar botón, 0 = No mostrar.
                const showReminder = row.tiene_recordatorio == 1;

                return (
                    <div className="d-flex align-items-center">
                        {showReminder && (
                            <div
                                className="d-flex align-items-center justify-content-center me-2 flex-shrink-0"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    borderRadius: '50%',
                                    backgroundColor: '#ffc107', // Amarillo
                                    cursor: 'pointer',
                                    border: '1px solid #ced4da',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenRecordatorios(
                                        row.pacienteID,
                                        `${row.pacienteNombre} ${row.pacienteApellido || ''}`
                                    );
                                }}
                                title="Ver Recordatorio"
                            >
                                <i className="bi bi-bell-fill text-dark" style={{ fontSize: '12px' }}></i>
                            </div>
                        )}
                        <span style={{ color }}><b>{row.pacienteNombre}</b></span>
                    </div>
                );
            },
            width: 230
        };

        const colNombreAuxiliar = {
            title: "Nombre Auxiliar",
            name: "auxiliarNombre",
            render: (row) => {
                const noEnviarStatus = getNoEnviarPacienteStatus(row);

                return (
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        <AuxiliarNombreCell row={row} />
                        {noEnviarStatus.active && (
                            <span className="badge bg-warning text-dark">
                                NO ENVIAR A ESTE DOMICILIO
                            </span>
                        )}
                    </div>
                );
            },
            getFilterValue: (row) =>
                row.reemplazoNombre && row.auxiliarID != null && row.es_reemplazo == 0
                    ? row.reemplazoNombre
                    : row.auxiliarNombre,
            width: 230
        };

        //
        // 🧩  Armado de bloques según mostrarExtendido
        //

        const fechaCompleta = {
            title: "Fecha",
            name: "fecha",
            render: (row) => (
                <span className={`${row.turno == "1" ? "text-blue" : "text-red"}`}>
                    {getDayOfWeek(row.fecha)} {formatDate(row.fecha)}
                </span>
            ),
            getFilterValue: (row) => `${getDayOfWeek(row.fecha)} ${formatDate(row.fecha)}`,
            width: 120
        };

        const nombreDia = {
            title: "Día",
            name: "fecha",
            render: (row) => (
                <span className={`${row.turno == "1" ? "text-blue" : "text-red"}`}>
                    {getDayOfWeek(row.fecha)}
                </span>
            ),
            getFilterValue: (row) => `${getDayOfWeek(row.fecha)}`,
            width: 100
        };
        const fechaDia = {
            title: "Fecha",
            name: "fecha",
            type: "date",
            render: (row) => (
                <span className={`${row.turno == "1" ? "text-blue" : "text-red"}`}>
                    {formatDate(row.fecha)}
                </span>
            ),
            getFilterValue: (row) => `${formatDate(row.fecha)}`,
            width: 120
        };

        const firstBlock = mostrarExtendido
            ? [colRutPaciente, colNombrePaciente]
            : [colNombrePaciente];

        const secondBlock = mostrarExtendido
            ? [colRutAuxiliar, colNombreAuxiliar, nombreDia, fechaDia]
            : [colNombreAuxiliar, fechaCompleta];

        //
        // 🔵  Resto de columnas originales
        //
        const otherColumns = [
            {
                title: "Turno",
                name: "tipo",
                render: (row) => (
                    <span className={`${row.turno == "1" ? "text-blue" : "text-red"}`}>
                        {row.turno == "1" ? "Día" : "Noche"}
                    </span>
                ),
                getFilterValue: (row) => `${row.turno == "1" ? "Día" : "Noche"}`,
                width: 60
            },

            {
                title: "Valor Turno",
                name: "valorTurno",
                render: (row) => {
                    if (
                        row.auxiliarNombre == '' ||
                        row.auxiliarNombre == "  " ||
                        row.auxiliarNombre == null ||
                        row.reemplazoValor <= 0
                    ) {
                        return '';
                    }

                    if (row.reemplazoValor > 0 && row.es_reemplazo == 0) {
                        return `$${formatMoney(row.reemplazoValor)}`;
                    }

                    return formatMoney(row.valorTurnoRt)
                        ? `$${formatMoney(row.valorTurnoRt)}`
                        : "";
                },
                width: 65,
                getFilterValue: (row) => `${row.valorTurnoRt}`,
            },

            {
                title: "Valor Movili..",
                name: "valorMovilizacion",
                render: (row) => {
                    if (
                        row.auxiliarNombre == '' ||
                        row.auxiliarNombre == "  " ||
                        row.auxiliarNombre == null ||
                        row.reemplazoValor <= 0
                    ) {
                        return '';
                    }

                    if (row.reemplazoValor > 0 && row.es_reemplazo == 0) {
                        return `$${formatMoney(row.reemplazoValorMovilizacion)}`;
                    }

                    return formatMoney(row.valorLocomocionRt)
                        ? `$${formatMoney(row.valorLocomocionRt)}`
                        : "";
                },
                width: 65,
                getFilterValue: (row) => `${row.valorLocomocionRt}`,
            },

            {
                title: "Valor Colación",
                name: "valorColacion",
                render: (row) => {
                    if (
                        row.auxiliarNombre == '' ||
                        row.auxiliarNombre == "  " ||
                        row.auxiliarNombre == null ||
                        row.reemplazoValor <= 0
                    ) {
                        return '';
                    }

                    if (row.reemplazoValor > 0 && row.es_reemplazo == 0) {
                        return `$${formatMoney(row.reemplazoValorColacion)}`;
                    }

                    return formatMoney(row.valorColacionRt)
                        ? `$${formatMoney(row.valorColacionRt)}`
                        : "";
                },
                width: 65,
                getFilterValue: (row) => `${row.valorColacionRt}`,
            },

            {
                title: "Notas",
                name: "notes",
                render: (row) => <NotasCell row={row} />,
                getFilterValue: (row) => NotasText(row),
                width: 350
            },

            {
                name: "id",
                title: "Acción",
                render: (row) => {
                    const hasAux = row.auxiliarID != null;
                    const esApoyo = row.es_apoyo === 1;
                    const es_reemplazo = row.es_reemplazo;
                    const con_nota = row.notes.trim() !== "";

                    return (
                        <div className="dropdown">
                            <button
                                className="btn btn-sm btn-primary dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Acciones
                            </button>

                            <ul className="dropdown-menu">

                                <li>
                                    <button
                                        className="dropdown-item text-primary"
                                        onClick={() => {
                                            setSelectedRow(row);
                                            reemplazarAuxiliar(row.id);
                                        }}
                                    >
                                        <i className="bi bi-arrow-repeat me-2"></i>
                                        {hasAux ? "Reemplazar" : "Asignar"}
                                    </button>
                                </li>

                                {!!es_reemplazo && (
                                    <li>
                                        <button
                                            className="dropdown-item text-primary"
                                            onClick={() => {
                                                setSelectedRow(row);
                                                devolverReemplazo(row);
                                            }}
                                        >
                                            <i className="bi bi-arrow-repeat me-2"></i>
                                            Devolver Reemplazo
                                        </button>
                                    </li>
                                )}

                                <li>
                                    <button
                                        className="dropdown-item text-secondary"
                                        onClick={() => {
                                            setSelectedRow(row);
                                            ingresarNota(row.id);
                                        }}
                                    >
                                        <i className="bi bi-pencil-square me-2"></i>
                                        Notas
                                    </button>
                                </li>

                                <li>
                                    <button
                                        className="dropdown-item text-primary"
                                        onClick={() => {
                                            cambiarColor(row);
                                        }}
                                    >
                                        <i className="bi bi-palette me-2"></i>
                                        Cambiar Color
                                    </button>
                                </li>

                                <li>
                                    <button
                                        className="dropdown-item text-success"
                                        onClick={() => {
                                            if (row.auxiliarID) {
                                                setAuxiliarForVacaciones({
                                                    id: row.auxiliarID,
                                                    nombreAuxiliar: row.auxiliarNombre
                                                });
                                                setIsVacacionesOpen(true);
                                            } else {
                                                gdAlertify.notiError("No hay un auxiliar asignado a este turno.");
                                            }
                                        }}
                                    >
                                        <i className="bi bi-calendar-check me-2"></i>
                                        Vacaciones
                                    </button>
                                </li>

                                {con_nota && (
                                    <li>
                                        <button
                                            className="dropdown-item text-danger"
                                            onClick={() => {
                                                setSelectedRow(row);
                                                eliminarNota(row);
                                            }}
                                        >
                                            <i className="bi bi-trash me-2"></i>
                                            Eliminar Nota
                                        </button>
                                    </li>
                                )}

                                {!esApoyo && (
                                    <li>
                                        <button
                                            className="dropdown-item text-warning"
                                            onClick={() => {
                                                crearTurnoApoyo(row);
                                            }}
                                        >
                                            <i className="bi bi-person-plus me-2"></i>
                                            Turno Apoyo
                                        </button>
                                    </li>
                                )}

                                <li>
                                    <button
                                        className="dropdown-item text-success"
                                        onClick={() => {
                                            setSelectedRow(row);
                                            ingresarAdicional(row.id);
                                        }}
                                    >
                                        <i className="bi bi-plus-circle me-2"></i>
                                        Adicional
                                    </button>
                                </li>

                                {row.adicionales?.length > 0 && (
                                    <li>
                                        <button
                                            className="dropdown-item text-info"
                                            onClick={() => {
                                                setSelectedRow(row);
                                                setIsAdicionalesModalOpen(true);
                                            }}
                                        >
                                            <i className="bi bi-list-ul me-2"></i>
                                            Ver Adicionales
                                        </button>
                                    </li>
                                )}

                                {row.adicionales?.length > 0 && (
                                    <li>
                                        <button
                                            className="dropdown-item text-danger"
                                            onClick={() => {
                                                setSelectedRow(row);
                                                setIsEliminarAdicionalesMasivoOpen(true);
                                            }}
                                        >
                                            <i className="bi bi-trash me-2"></i>
                                            Eliminar Adicionales
                                        </button>
                                    </li>
                                )}

                                {hasAux && (
                                    <>
                                        <li>
                                            <button
                                                className="dropdown-item text-dark"
                                                onClick={() => {
                                                    setSelectedRow(row);
                                                    actualizarValores(row);
                                                }}
                                            >
                                                <i className="bi bi-currency-dollar me-2"></i>
                                                Actualizar Valores
                                            </button>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item text-warning"
                                                onClick={() => {
                                                    handleOpenNoEnviar(row);
                                                }}
                                            >
                                                <i className="bi bi-exclamation-triangle me-2"></i>
                                                No Enviar a Este Domicilio
                                            </button>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item text-secondary"
                                                onClick={() => {
                                                    handleOpenObservation(row);
                                                }}
                                            >
                                                <i className="bi bi-chat-left-text me-2"></i>
                                                Obs. Auxiliar
                                            </button>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item text-danger"
                                                onClick={() => {
                                                    setSelectedRow(row);
                                                    eliminarTurno(row);
                                                }}
                                            >
                                                <i className="bi bi-trash me-2"></i>
                                                Eliminar
                                            </button>
                                        </li>
                                    </>
                                )}

                                <li>
                                    <button
                                        className="dropdown-item text-primary"
                                        onClick={() => {
                                            setSelectedRow(row);
                                            obtenerTurnos(startMonth, searchPatient);
                                        }}
                                    >
                                        <i className="bi bi-arrow-repeat me-2"></i>
                                        Actualizar
                                    </button>
                                </li>

                            </ul>
                        </div>
                    );
                },
                width: 70
            }
        ];

        //
        // 🧩 Retorna columnas completas en orden
        //
        return [
            ...firstBlock,
            ...secondBlock,
            ...otherColumns,
        ];

    }, [turnos, mostrarExtendido]);


    return (
        <div className="container-fluid mt-4">
            <div className="card">
                <div className="card-header">
                    <h4 className="mb-0">Calendario Turnos</h4>
                </div>
                <div className="card-body">
                    {/* Formulario de búsqueda */}
                    <div className="row mb-4">
                        <div className="col-md-4 mb-3">
                            <BuscarPaciente onSelect={handleSeleccionPaciente} onClear={handleSeleccionPaciente} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">Periodo</label>
                            <input
                                type="month"
                                className="form-control"
                                placeholder="Mes de inicio"
                                value={startMonth}
                                onChange={handleMonthChange} // Cambiar mes
                            />
                        </div>
                        <div className="col-md-2 mb-3">
                            <button
                                className="btn btn-primary w-100"
                                onClick={() => obtenerTurnos(startMonth, searchPatient)} // Ejecutar la búsqueda al hacer clic
                            >
                                Buscar Turnos
                            </button>
                        </div>
                        <div className="col-md-4 form-check ms-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="mostrarExtendido"
                                checked={mostrarExtendido}
                                onChange={(e) => setMostrarExtendido(e.target.checked)}
                            />
                            <label className="form-check-label ms-2" htmlFor="mostrarExtendido">
                                Ver Registro de turnos Extendido
                            </label>
                        </div>
                    </div>

                    {/* Tabla de turnos */}
                    <GdTable
                        columns={columns}
                        data={turnos}
                        itemsPerPageOptions={[50, 100, 300, 1000, 2000, 4000, 6000]} // Opciones de elementos por página
                        defaultItemsPerPage={20000}
                        // initialSort={[0, "asc"]}
                        tableClassName="table table-bordered"
                        showCsvExport={true}
                        height={700}
                        separadorPorCampo="pacienteNombre"
                        virtualize
                        getRowClass={(row) => {
                            // === Eliminado ===
                            if (row?.es_eliminado) return 'bg-row-eliminado';

                            // === NUEVO: Colores Manuales (2: Azul, 3: Amarillo, 1: Ninguno) ===
                            // Si está manual el manual manda
                            if (row?.color === 2) return 'bg-row-reemplazo'; // Azul manual
                            if (row?.color === 3) return 'bg-row-marca';     // Amarillo manual
                            if (row?.color === 1) return '';                 // Manual Ninguno (Quita automático)

                            // === FUERA DE STGO (Prioridad Automática) ===
                            // Si el paciente vive fuera de santiago, el turno es verde
                            if (row?.vive_fuera_santiago == 1) return 'bg-row-verde';

                            if (Array.isArray(row?.adicionales)) {
                                const esFueraStgo = row.adicionales.some(a => {
                                    const horasExtras = Number(a.horasExtras ?? 0);
                                    const valorTurno = Number(a.valorTurno ?? 0);
                                    return (a.fueraStgo === 1 && horasExtras === 0 && valorTurno !== 0);
                                });
                                if (esFueraStgo) return "bg-row-fuera-stgo";
                            }

                            // === Reemplazo / Apoyo (Asignado - Prioridad sobre marca automática) ===
                            if (row?.es_reemplazo || row?.es_apoyo) return 'bg-row-reemplazo';

                            // === Marca amarillo automático ===
                            if (row?.marca) return 'bg-row-marca';

                            // === Solicitud de reemplazo (Pendiente) ===
                            if (row?.solicitud_reemplazo && row.solicitud_estado == 0)
                                return 'bg-row-solicitud-reemplazo';

                            if (row?.solicitud_reemplazo)
                                return 'bg-row-reemplazo';

                            // === NUEVO: Múltiples Adicionales (Warning) ===
                            if (row?.adicionales?.length > 1) return 'bg-row-rojo-claro';

                            return '';
                        }}


                        exportFilename={`registro-turnos-${startMonth}.xlsx`}
                    />

                    {turnos.length === 0 && (
                        <div className="alert alert-info">No se encontraron turnos que coincidan con la búsqueda.</div>
                    )}
                </div>
            </div>
            {isReemplazoOpen && (
                <ReemplazarAuxiliar
                    isOpen={isReemplazoOpen}
                    row={selectedRow}
                    onClose={() => {
                        setIsReemplazoOpen(false);
                        obtenerTurnos(startMonth, searchPatient);
                    }}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                    periodo={startMonth}
                />
            )}
            {isAdicionalOpen && (
                <IngresoAdicional
                    isOpen={isAdicionalOpen}
                    row={selectedRow}
                    onClose={() => setIsAdicionalOpen(false)}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                />
            )}
            {isNotaOpen && (
                <NotaModal
                    isOpen={isNotaOpen}
                    row={selectedRow}
                    onClose={() => {
                        setIsNotaOpen(false);
                        obtenerTurnos(startMonth, searchPatient);
                    }}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                />
            )}
            {isEliminarNotaOpen && (
                <EliminarNotaModal
                    isOpen={isEliminarNotaOpen}
                    row={selectedRow}
                    periodo={startMonth}
                    onClose={() => setIsEliminarNotaOpen(false)}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                />
            )}
            {isValorAdicionalOpen && (
                <ModalValorAdicional
                    isOpen={isValorAdicionalOpen}
                    row={selectedRow}
                    onClose={() => setIsValorAdicionalOpen(false)}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                />
            )}
            {isAdicionalesModalOpen && (
                <ModalAdicionales
                    isOpen={isAdicionalesModalOpen}
                    row={selectedRow}
                    onClose={() => setIsAdicionalesModalOpen(false)}
                    onEditar={(item) => {
                        // Preparamos el row con la info del adicional para editar
                        // Importante: asegurarnos de pasar el ID del adicional
                        const datosEdicion = {
                            ...selectedRow, // mantiene pacienteID, fecha base, etc.
                            
                            // Guardamos el auxiliar original del turno para comparar
                            auxiliarTurnoID: selectedRow.auxiliarID,

                            ...item,        // sobreescribe con valores del adicional (valorTurno, horasExtras, etc)
                            idAdicional: item.adicionalID, // Para que el backend sepa que es edición
                            
                            // Mapeo específico de campos si difieren nombres
                            // En ModalAdicionales el item tiene: valorTurno, valorColacion, etc.
                            // IngresoAdicional espera esos mismos nombres en 'row' o los carga en useEffect.
                            
                            // Ajustar auxiliarID si el item tiene uno distinto
                            // Nota: IngresoAdicional usa row.auxiliarID o row.reemplazoID por defecto.
                            // Si el adicional tiene un auxiliar específico, hay que pasarlo.
                            auxiliarID: item.auxiliarID || selectedRow.auxiliarID,
                            auxiliarNombre: item.auxiliarNombre || selectedRow.auxiliarNombre,
                            
                            // Ajustar RemplazoID (Paga SK / Cobro Paciente)
                            auxiliarRemplazoID: item.auxiliarRemplazoID, 
                            
                            // Ajustar fecha si la del adicional es distinta (aunque suele ser la misma o rango)
                            fecha: item.fechaAdicional || selectedRow.fecha,
                        };

                        setSelectedRow(datosEdicion);
                        setIsAdicionalesModalOpen(false); // Cerramos lista
                        setIsAdicionalOpen(true);         // Abrimos formulario
                    }}
                    onEliminar={async (adicionalID) => {
                        gdAlertify.confirm({
                            title: "Eliminar Adicional",
                            message: "¿Estás seguro de eliminar este adicional?",
                            onConfirm: async () => {
                                gdAlertify.showLoader();
                                try {
                                    const response = await axiosInstance.post(`/acuerdo-mutuo/adicional/eliminar/${adicionalID}`);
                                    if (!response.data.error) {
                                        gdAlertify.notiSuccess("Adicional eliminado correctamente.");
                                        obtenerTurnos(startMonth, searchPatient);
                                        setIsAdicionalesModalOpen(false);
                                    } else {
                                        gdAlertify.notiError(response.data.message);
                                    }
                                } catch (err) {
                                    gdAlertify.notiError("Error al eliminar el adicional.");
                                } finally {
                                    gdAlertify.hideLoader();
                                }
                            },
                        });
                    }}
                />
            )}
            {isEliminarOpen && (
                <EliminarTurnoModal
                    isOpen={isEliminarOpen}
                    row={selectedRow}
                    periodo={startMonth}
                    onClose={() => setIsEliminarOpen(false)}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                />
            )}
            {isActualizarValoresOpen && (
                <ActualizarValoresModal
                    isOpen={isActualizarValoresOpen}
                    row={selectedRow}
                    onClose={() => setIsActualizarValoresOpen(false)}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                />
            )}
            {isRecordatoriosOpen && (
                <ModalRecordatoriosPaciente
                    isOpen={isRecordatoriosOpen}
                    onClose={() => {
                        setIsRecordatoriosOpen(false);
                        // Recargar la tabla si es necesario para actualizar el icono de la campana
                        // obtenerTurnos(startMonth, searchPatient); 
                    }}
                    pacienteId={recordatorioPacienteId}
                    pacienteNombre={recordatorioPacienteNombre}
                />
            )}
            {isEliminarAdicionalesMasivoOpen && (
                <EliminarAdicionalesMasivoModal
                    isOpen={isEliminarAdicionalesMasivoOpen}
                    periodo={startMonth}
                    pacienteID={selectedRow?.pacienteID}
                    pacienteNombre={selectedRow?.pacienteNombre}
                    rowFecha={selectedRow?.fecha}
                    onClose={() => setIsEliminarAdicionalesMasivoOpen(false)}
                    onConfirm={() => { obtenerTurnos(startMonth, searchPatient); }}
                />
            )}
            {isObservationModalOpen && (
                <ObservationAuxiliarModal
                    isOpen={isObservationModalOpen}
                    onClose={() => setIsObservationModalOpen(false)}
                    auxiliarID={selectedRow?.auxiliarID}
                    auxiliarNombre={
                        selectedRow?.reemplazoNombre && selectedRow?.auxiliarID != null && selectedRow?.es_reemplazo == 0
                            ? selectedRow?.reemplazoNombre
                            : selectedRow?.auxiliarNombre
                    }
                />
            )}
            {isNoEnviarOpen && (
                <NoEnviarPacienteAuxiliarModal
                    isOpen={isNoEnviarOpen}
                    onClose={() => {
                        setIsNoEnviarOpen(false);
                        setNoEnviarContext(null);
                    }}
                    onChange={() => {
                        obtenerTurnos(startMonth, searchPatient);
                    }}
                    auxiliarID={noEnviarContext?.auxiliarID}
                    nombreAuxiliar={noEnviarContext?.nombreAuxiliar}
                    pacienteID={noEnviarContext?.pacienteID}
                    nombrePaciente={noEnviarContext?.pacienteNombre}
                />
            )}
            <ColorTurnoModal
                isOpen={isColorOpen}
                onClose={() => setIsColorOpen(false)}
                onConfirm={() => obtenerTurnos(startMonth, searchPatient)}
                row={selectedRow}
                periodo={startMonth}
            />
            <VacacionesModal
                isOpen={isVacacionesOpen}
                onClose={() => setIsVacacionesOpen(false)}
                auxiliarID={auxiliarForVacaciones?.id}
                nombreAuxiliar={auxiliarForVacaciones?.nombreAuxiliar}
            />
        </div>
    );
};

export default CalendarioTurnos;
